module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "479",
      "src": "images/Gothic69_fmt.jpg",
      "width": "396"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "accomplice"
    }
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-7",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Accomplice")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("These easy-to-make hand-warmers can be worn with or without gloves underneath. Worked in a luscious silk/mohair blend yarn, they keep the wrist and forearm warm and sweep gracefully \n\t\t\t\tover the top of the hand. The barred pattern is \n\t\t\t\tcreated by passing yarnovers over the subsequent stitches, making a channel of yarn floats. The hand edge is finished with a few rows of a slipped stitch pattern, and the thumb hole is created by making a few chain stitches from the last stitch of the bind-off row and attaching it to a spot on the opposite side.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('a', {
    attrs: {
      "id": "accomplice"
    }
  }), _c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "accomplice"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Sizes"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Approximately 7¾\" wrist circumference; "), _c('br'), _vm._v("approximately 9¼\" hand circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Yarn"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Fleece Artist Kid Silk 3-ply (70% kid mohair / 30% silk; 220 yards [201 meters] / 100 grams): 1 hank vintage")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Needles"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("One set of four double-pointed needles (dpn) size US 7 (4.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Notions"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Crochet hook size US 7 (4.5 mm); stitch marker")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Gauge"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("18 sts and 24 rnds = 4\" (10 cm) in Barred Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('br')]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Stitch Patterns")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Barred Pattern")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-2",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("(multiple of 5 sts; 2-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("*Yo, k2, pass yo over last 2 sts worked, k3; repeat from * around."), _c('br'), _vm._v("Repeat Rnds 1 and 2 for Barred Pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Linen Stitch")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-2",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("(multiple of 2 sts; 2-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" *K1, slip 1 purlwise wyif; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("*Slip 1 purlwise wyif, k1; repeat from * around."), _c('br'), _vm._v("Repeat Rnds 1 and 2 for Linen Stitch.")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "accomplice"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Hand Warmers (both alike)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("With Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", CO 35 sts, divide among 3 needles [12-12-11]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. Begin Barred Pattern. Work even for 31 rows (work should measure approximately 5¼\" from the beginning)."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Increase Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("*Yo, k2, pass yo over last 2 sts worked, k2, M1L, k1; repeat from * around–42 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" *Yo, k2, pass yo over last 2 sts worked, k4; repeat from * around. "), _c('br'), _vm._v("Repeat last 2 rnds 6 times. Knit 1 rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" Change to Linen st. Work even for 5 rnds."), _c('br'), _vm._v("BO 41 sts–1 st remains. Cut yarn, leaving a long tail. Insert crochet hook into last st and ch 6. Fasten off. Sew end of chain approximately 12 sts away from beginning of chain along BO edge, creating a thumb hole.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Gothic28.tiff",
      "height": "479",
      "src": "images/Gothic28_fmt.jpg",
      "width": "396"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "aethelwyne"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "KnittingBook104.tiff",
      "height": "479",
      "src": "images/KnittingBook104_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "aethelwyne"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Aethelwyne")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("An elfin shape and a rustic yarn combine to create an otherworldly mitten, which will nonetheless keep both children and adults warm in this realm. The bobble ring crowning the fluted cuff represents a fairy ring, which is a ring of mushrooms, in the center of which no mushrooms grow and fairies are said to dance. Aethelwyne is an Old English name meaning “friend of the elves.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "aethelwyne"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Small (Medium, Large)"), _c('br'), _vm._v("To fit Small Child (Medium Child, Woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 5½ (6½, 7½)\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Harrisville Designs New England Highland "), _c('br'), _vm._v("(100% wool; 200 yards [183 meters] / "), _c('br'), _vm._v("100 grams): 1 hank #07 tundra "), _c('br'), _vm._v("(#74 rose, #15 loden blue)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One set of five double-pointed needles (dpn) size US 6 (4 mm)"), _c('br'), _vm._v("One set of five double-pointed needles size US 5 (3.75 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stitch marker; waste yarn in contrasting color")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("20 sts and 28 rnds = 4\" (10 cm) in Stockinette stitch (St st) using larger needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Abbreviations"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("(MB) Make Bobble:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" [K1, p1, k1] in next st, turn work, k3, turn work, p3, pass first and second sts over third st and off the needle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("All sts are slipped purlwise with yarn in back unless otherwise indicated.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Right Mitten")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "aethelwyne"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With smaller needles and Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", CO 30 (35, 45) sts, divide among 3 needles [10-10-10 (15-10-10, 15-15-15)]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd.")]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Begin Pattern:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K3, p2; repeat from * around."), _c('br'), _vm._v("Work even for 12 (13, 15) rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K3, p2tog; repeat from * around–24 (28, 36) sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K3, p1; repeat from * around."), _c('br'), _vm._v("Work even for 1 (2, 3) rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Bobble Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K1, MB, k1, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K1, slip 1, k1, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K3, p1; repeat from * around."), _c('br'), _vm._v("Work even for 0 (1, 2) rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hand"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to larger needles and St st (knit every rnd). *K1 (1, 0), M1R, k10 (12, 18), M1L, k1 (1, 18); repeat from * 1 (1, 0) time–28 (32, 38) sts. "), _c('br'), _vm._v("Redistribute sts among 4 needles [7-7-7-7 (8-8-8-8, 10-9-10-9)]. Work even until piece measures approximately 1¼ (1½, 2½)\" from end of Cuff.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K15 (17, 20), change to waste yarn and k5 (6, 7), slip these 5 (6, 7) sts back to left-hand needle, change to working yarn, knit these 5 (6, 7) sts again, knit to end. Work even until piece measures approximately 2¾ (3¼, 5)\" from end of Cuff.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Mitten Top")]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K5 (14, 17), k2tog; repeat from * around–24 (30, 36) sts remain. Work even for 1 rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K4, k2tog, repeat from * around–20 (25, 30) sts remain. Work even for 3 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K3, k2tog; repeat from * around–16 (20, 24) sts remain. Work even for 3 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2, K2tog; repeat from * around–12 (15, 18) sts remain. Work even for 3 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, k2tog; repeat from * around–8 (10, 12) sts remain. Work even for 3 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * around–4 (5, 6) sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off."), _c('br'), _c('br')]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Carefully remove waste yarn from Thumb sts and place bottom 5 (6, 7) sts and top 6 (7, 8) sts onto 2 larger dpns, being careful not to twist sts. Rejoin yarn to bottom sts, pick up and knit 1 (1, 2) sts at side of Thumb Opening, knit across 5 (6, 7) bottom sts, pick up and knit 1 (1, 2) sts at other side of Thumb Opening, knit across 6 (7, 8) top sts–13 (15, 19) sts. Redistribute sts evenly among 3 dpns. Join for working in the rnd; pm for beginning of rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Children’s Sizes Only"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2tog, k3 (4), ssk, k6 (7)–11 (13) sts remain. Work even in St st until piece is long enough to cover thumb."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to last st, k1–6 (7) sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight, fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Woman’s Size Only"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, k2tog, k5, ssk, k2tog, k6, ssk (last st of this rnd together with first st of next rnd)–15 sts remain. Work even in St st until piece is ¼\" from end of thumb (approximately 14 more rnds)."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, k2tog; repeat from * around–10 sts remain. Work even for 3 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * around–5 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Left Mitten")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Right Mitten to Thumb Opening.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K22 (25, 30), change to waste yarn, k5 (6, 7), slip these 5 (6, 7) sts back to left-hand needle, change to working yarn, knit these 5 (6, 7) sts again, knit to end. Complete as for Right Mitten.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends. Block mittens. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "KnittingBook93.tiff",
      "height": "240",
      "src": "images/KnittingBook93_fmt.jpg",
      "width": "198"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "alesund"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "KnittingBook38.tiff",
      "height": "479",
      "src": "images/KnittingBook38_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "alesund"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-17"
  }, [_vm._v("å")]), _c('span', {
    staticClass: "Introduction-Project-Title char-style-override-18",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("lesund")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("These multicolored mittens have traditional Norwegian roots. The Art Nouveau-style motif on the top of the hand—definitely a modern touch—is an unexpected counterpoint to the striped palm. The cuff is edged with a few rows \n\t\t\t\tof gently flaring Stockinette stitch, which in this \n\t\t\t\trobust yarn is easy to block flat. The main \n\t\t\t\tpattern is knitted in two colors, and additional \n\t\t\t\tcolors are added later using duplicate stitch. \n\t\t\t\tThe mitten is named for a Norwegian town that \n\t\t\t\twas (and is today) an important center in the \n\t\t\t\t"), _c('span', {
    staticClass: "Introduction-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xmlns": "http://www.w3.org/1999/xhtml"
    }
  }, [_vm._v("Jugendstil")]), _vm._v(" “youth style”) movement, a German \n\t\t\t\tvariant of Art Nouveau.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "alesund"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-20",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements")]), _c('span', {
    staticClass: "char-style-override-20",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7¾\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-20",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rauma 3-ply Strikkegarn (100% wool; "), _c('br'), _vm._v("115 yards [105 meters] / 50 grams): "), _c('br'), _vm._v("2 balls #136 black (MC); 1 ball each #140 mauve (A), #180 wine (B), #146 gold (C), and #150 acid yellow (D)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-20",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One set of five double-pointed needles (dpn) size US 3 (3.25 mm)"), _c('br'), _vm._v("One set of five double-pointed needles size US 4 (3.5 mm)"), _c('br'), _vm._v("One set of five double-pointed needles size US 6 (4 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; waste yarn in contrasting color")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-20",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("24 sts and 25 rnds = 4\" (10 cm) in Stockinette stitch (St st) over Fair Isle Chart using size US 4 (3.5 mm) needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stitch Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-18",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Corrugated Rib Pattern")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("(multiple of 4 sts; 12-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" *K2 with MC, k2 with A; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Rnds 2-5: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("*K2 with MC, p2 with A; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Rnds 6 and 7: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("*K2 with MC, p2 with B; repeat from * around. Cut B after Rnd 7."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Rnds 8-12:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" Repeat Rnd 2.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-18",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("2-Color Palm Pattern")]), _c('span', {
    staticClass: "char-style-override-21",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("(multiple of 2 sts + 1; 1-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Rnds:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1 with A, *k1 with MC, k1 with A; repeat from * around."), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Mitten")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "alesund"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff")]), _c('span', {
    staticClass: "char-style-override-21",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With MC, Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", and largest dpns, CO 44 sts, divide among 4 dpns (12-10-12-10). Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. Begin St st; work even for 4 rnds."), _c('br'), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to smallest needles and Corrugated Rib Pattern. Work even for 12 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hand")]), _c('span', {
    staticClass: "char-style-override-21",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to size US 4 (3.5 mm) needles and MC. *K22, M1L; repeat from * around–46 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work Fair Isle Chart across 23 sts, pm, change to 2-Color Palm Pattern, work to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Continuing Fair Isle Chart as established, work 23 sts, slip marker (sm), change to 2-Color Palm Pattern, work to end. Work even until Rnd 17 of Chart is complete.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 18:")]), _c('span', {
    staticClass: "char-style-override-21",
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 23 sts, k1 with A, transfer next 9 sts to waste yarn for Thumb, CO 9 sts over gap using Backward Loop CO "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", alternating MC and A, corresponding to color of st being replaced, work to end. Work even until Row 39 of Chart is complete.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Mitten Top")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Working decreases as shown in Chart, work to first marker, sm, k1 with A, ssk with MC, work to last 3 sts, k2tog with MC, k1 with A–42 sts remain. Repeat Decrease Rnd 1 every rnd 8 times–10 sts remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work to first marker, sm, k1 with A, dcd with MC, k1 with A–6 sts remain. Cut both yarns, leaving long tails. With MC, draw through remaining sts, pull tight and fasten off. Weave in ends on WS.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    staticClass: "char-style-override-21",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpn. Rejoin MC and A. Beginning at side of Thumb with A, pick up and knit 2 sts from gap (not from sts CO above Thumb), knit across Thumb sts in ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("appropriate colors, with A, pick up and knit 2 sts ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("from gap at other side of Thumb, pick up and knit 9 sts from sts CO above Thumb using appropriate colors and picking up from the middle of each stitch–22 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ssk with A, knit next 9 sts in established colors, k2tog with A, knit next 9 sts in established colors–20 sts remain. Work even until piece measures approximately 2½\", or until piece is long enough to cover tip of thumb. Cut A, leaving long tail.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*With MC, k2tog; repeat from * around–10 sts remain. Cut yarn, leaving long tail. With MC, draw through remaining sts, pull tight and fasten off. Weave in ends on WS.")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Left Mitten")]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Right Mitten to Thumb Opening.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 23 sts, work in 2-Color Palm Pattern across 13 sts, transfer next 9 sts to waste yarn for Thumb, CO 9 sts over gap using Backward Loop CO, alternating MC and A, corresponding to color of st being replaced, work to end. Complete as for Right Mitten. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-21",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Block Mittens to even out sts prior to working Duplicate Stitch "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 137)")]), _vm._v(". Pay special attention to flare at lower edge of Mittens; pin flat and steam with iron (set on wool) and damp cloth. When Mittens are dry, work Duplicate Stitch as indicated in Chart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "AlesundChart.eps",
      "src": "images/FairIsleChart.jpg",
      "width": "320"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "alternatingCurrent"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Wristlettes9.tiff",
      "height": "479",
      "src": "images/Wristlettes9_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "alternatingCurrent"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-7",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Alternating Current")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Two different mittens are presented here: a full mitten and a fingerless mitten. Buttons at the wrist allow the cuffs to be changed like bracelets. Make both types of cuffs in different colors, then alternate them to suit your mood. The fingerless version could be worn indoors in a chilly workplace or outside \n\t\t\t\twhen you need your fingers free.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "alternatingCurrent"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 8\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Brown Sheep Company Lamb’s Pride Bulky (85% wool / 15% mohair; 125 yards "), _c('br'), _vm._v("[114 meters] / 113 grams): Mittens: "), _c('br'), _vm._v("2 skeins #M-185 aubergine (MC), 1 skein #M-175 bronze patina (A); Fingerless "), _c('br'), _vm._v("Mittens: 2 skeins #M-58 ink blue (MC), "), _c('br'), _vm._v("1 skein #M-25 garnet (A); Cuffs also shown in #M-23 fuchsia (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 10½ (6.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch marker; waste yarn; cable needle (cn); four ¾\" buttons")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("13 sts and 19 rnds = 4\" (10 cm) in Stockinette stitch (St st)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Full Mittens")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "alternatingCurrent"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Left Mitten")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With MC and Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", CO 26 sts, divide among 4 needles [7-6-7-6]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. "), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Needles 1 and 2 form the back of the Mitten; Needles 3 and 4 form the palm.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Begin St st (knit every rnd). Work even until piece measures approximately 9\" from the beginning, or to desired length to base of thumb.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K21, change to waste yarn and k4, slip these 4 sts back to left-hand needle, change to working yarn, knit these 4 sts again, k1. Work even until piece measures 3½\" from Thumb Opening, or until Mitten reaches first knuckle of middle finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Mitten Top")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Ssk, knit to last 2 sts on Needle 2, k2tog, ssk, knit to last 2 sts on Needle 4, k2tog–22 sts remain. Knit 1 rnd. Repeat Decrease Rnd every other rnd twice–14 sts remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from Needle 2 to Needle 1 and sts from Needle 4 to Needle 3. Graft sts together using "), _c('br'), _vm._v("Kitchener Stitch "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 139)")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Carefully remove waste yarn from Thumb sts and place bottom 4 sts and top 5 sts onto 2 dpns, being careful not to twist sts. Rejoin yarn to bottom sts, pick up and knit 1 st at side of Thumb Opening, knit across 4 bottom sts, pick up and knit 1 st at other side of Thumb Opening, knit across 5 top sts–11 sts. Redistribute sts among 3 dpns. Join for working in the rnd; pm for beginning of rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K2tog, k2, ssk, k5–9 sts remain. Work even until piece is long enough to cover thumb."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * to last st, k1–5 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Right Mitten"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Mitten to Thumb Opening. "), _c('br')]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Terms for “back of hand” and “palm” should be reversed.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K14, change to A and k4, slip these 4 sts back to left-hand needle, change to working yarn, knit these 4 sts again, knit to end. Complete as for Left Mitten.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Fingerless Mittens")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Left Mitten"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Full Mitten until piece measures 2¼\" from Thumb Opening, or until Mitten covers base of fingers. BO all sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Full Mitten until 9 sts remain. Work even for 3 rnds. BO all sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Right Mitten"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Right Full Mitten until piece measures 2¼\" from Thumb Opening, or until Mitten covers base of fingers. Complete as for Left Fingerless Mitten.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Smocked Cuffs (make 2)")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With A, CO 32 sts, divide among 4 needles [8-8-8-8]. Join for working in the rnd, being careful not to twist sts; pm for beginning of rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 1-3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K1, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *Transfer next 3 sts to cn, wrap yarn once around these sts counterclockwise (pulling gently), transfer these sts to right-hand needle, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 5: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 6 (Buttonhole Rnd):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *[K1, p1] 7 times, ssk, yo; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 7: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 8: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Slip first st of rnd to Needle 4, *p1, transfer next 3 sts to cn, wrap yarn once around these sts counterclockwise (pulling gently), transfer these sts to right-hand needle; repeat from * around.")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [Note: Sts may need to be redistributed among the needles for wrapping.] ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer last st on Needle 4 back to Needle 1."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 9-10: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, p1; repeat from * around. BO all sts in pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ribbed Cuffs (make 2)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With A, CO 24 sts, divide among 4 needles [6-6-6-6]. Join for working in the rnd, being careful not to twist sts; pm for beginning of rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2, p2; repeat from * around. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Buttonhole Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *[K2, p2] 2 times, k2, yo, p2tog; repeat from * around. Work even for 4 rnds. BO all sts in pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends. Sew a button to each side of wrist. Pull Cuff on and button at wrist.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "blackthorn"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Blackthorn74.tiff",
      "height": "479",
      "src": "images/Blackthorn74_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "blackthorn"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-7",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Blackthorn")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("The blackthorn is a tree that produces the \n\t\t\t\tsmall fruit known as sloe berries, from which \n\t\t\t\tsloe gin is made. A cocktail of the same \n\t\t\t\tname is made from sloe gin and sweet vermouth. These fitted gloves, worked in a lovely and \n\t\t\t\tstrong Shetland wool with the unusual addition \n\t\t\t\tof leather lacing on the back of the hand, \n\t\t\t\tremind me of that cocktail: a mysterious elixir \n\t\t\t\twith a sharp name, not overly sweet. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "blackthorn"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Women’s Small/Medium (Large)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7¼ (8)\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Jamieson’s Shetland Double Knitting (100% pure Shetland wool; 82 yards "), _c('br'), _vm._v("[75 meters] / 25 grams): 3 balls #293 port wine (MC) "), _c('br'), _vm._v("Jamieson’s Shetland Spindrift (100% pure Shetland wool; 115 yards [105 meters] / 25 grams): 1 ball #238 osprey (A) ")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 4 (3.5 mm)"), _c('br'), _vm._v("One pair straight needles size US 1½ "), _c('br'), _vm._v("(2.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; waste yarn in contrasting color; crochet hook size US B/1 "), _c('br'), _vm._v("(2.25 mm), for picking up sts; 1 yard "), _c('br'), _vm._v("(1 meter) leather lacing")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("24 sts and 32 rows = 4\" (10 cm) in Stockinette stitch (St st) using larger needles and MC 32 sts and 44 rows = 4\" (10 cm) in Stockinette stitch using smaller needles and A"), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stitch Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("1x1 Rib")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("(multiple of 2 sts; 1-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Rnds: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, p1; repeat from * around."), _c('br'), _c('br')])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "blackthorn"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Left Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", dpn, and MC, CO 44 (48) sts, divide among 4 needles [11-11-11-11 (12-12-12-12)]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. "), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note: Needles 1 and 2 hold the sts for the palm and Thumb, and Needles 3 and 4 hold the sts for the back of the hand.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Begin 1x1 Rib. Work even for 4 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to St st; work even for 7 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K9 (10), k2tog; repeat from * around–40 (44) sts remain. Work even for 7 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K8 (9), k2tog; repeat from * around–36 (40) sts remain. Work even for 7 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K9 (10), M1L; repeat from * around–40 (44) sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K5, *M1L, k10 (11); repeat from * to last 5 (6) sts, M1L, knit to end–44 (48) sts. Work even for 2 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K20 (22), pm, M1L, k2, M1R, pm, knit to end–46 (50) sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit to first marker, slip marker (sm), M1L, knit to second marker, M1R, sm, knit to end. Repeat last 3 rnds 5 times–58 (62) sts. Knit 1 rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K20 (22), transfer next 16 sts to waste yarn, CO 2 sts over gap, knit to end–44 (48) sts remain. Work even until piece is long enough to reach base of Pinkie, ending 5 (6) sts before end of rnd, removing all markers on last rnd. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Divide for Fingers"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 10 (12) sts [last 5 (6) sts of rnd and first 5 (6) sts of next rnd] to waste yarn, pm, CO 2 sts over gap, knit to 5 sts before marker. "), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ring Finger: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 12 sts [5 sts from back, 2 CO sts from previous rnd, and 5 sts from palm] to waste yarn, removing marker, pm, CO 2 sts over gap, knit to 5 (6) sts before marker. "), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Middle Finger:")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 12 (14) sts [5 (6) sts from back, 2 CO sts from previous rnd, and 5 (6) sts from palm] to waste yarn, pm, CO 2 sts over gap–16 sts remain for Index Finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work in St st until piece is long enough to cover index finger (approximately 22 rnds).")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * to end–8 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Middle, Ring, and Pinkie Fingers, and Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Working one finger at a time, transfer sts from waste yarn to dpns. Rejoin MC; pick up and knit 2 sts from CO between previous Finger and current Finger (or from sts CO over gap for Thumb)–14 (16) sts for Middle Finger [14 sts for Ring Finger; 12 (14) sts for Pinkie; 18 sts for Thumb]. Join for working in the rnd; pm for beginning of rnd. Work in St st until piece is long enough to cover finger (approximately 27 rnds for Middle Finger, 25 rnds for Ring Finger, 21 rnds for Pinkie, and 20 rnds for Thumb). Complete as for Index Finger–7 (8) sts remain for Middle Finger [7 sts for Ring Finger; 6 (7) sts for Pinkie; 9 sts for Thumb].")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Glove to beginning of Thumb Shaping.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K22 (24), pm, M1L, k2, M1R, pm, knit to end–46 (50) sts. Complete as for Left Glove, working Fingers in the same order. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Terms for “back of hand” and “palm” should be reversed.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Block Gloves."), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Lacers")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Left Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Side: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With RS facing, using crochet hook and A, beginning where Thumb Opening ends and ending near base of Thumb, pick up 25 sts from between the first and second st columns to the left of the Thumb, as follows: Working with A on RS, insert crochet hook under the horizontal strand between the sts, draw up a loop and leave on hook. Work into every row, working from right to left. Transfer the 25 sts to straight needle, making sure that working yarn is at tip of needle, ready to work a WS row. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 1, 3, and 5 (WS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Purl."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 2 and 4: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 6: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K3, *[k1, p1, k1] into next st, k5; repeat from * to last 4 sts, [k1, p1, k1] into next st, k3–33 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 7: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Purl."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 8: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K4, *[k1, p1, k1] into next st, k7; repeat from * to last 5 sts, [k1, p1, k1] into next st, k4–41 sts. BO all sts knitwise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Heel of Hand Side: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pick up 25 sts as for Thumb side, reversing direction of pick-up [beginning even with base of Thumb and ending even with end of Thumb Opening], working between last 2 st columns of back of hand. Complete as for Thumb side.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Repeat for Right Glove, picking up sts for Thumb side from base of Thumb to end of Thumb Opening, and sts for heel of hand side from even with end of Thumb Opening to even with base of Thumb.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Lace leather ties through the holes created under the increases on Row 8, working from knuckles to wrist. Tie at wrist.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "boxPleats"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "BoxPleats330.tiff",
      "height": "479",
      "src": "images/BoxPleats330_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "boxPleats"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-22",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Box Pleats")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("A box pleat ornaments the cuff of these fingerless gloves: It is created by knitting together stitches \n\t\t\t\tfrom three layers that have been placed on \n\t\t\t\tspare needles and folded into the pleat shape. \n\t\t\t\tThe back of the hand is decorated with a \n\t\t\t\tbeaded twisted stitch pattern, and beads are \n\t\t\t\tincorporated into the bind-off as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "boxPleats"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7½\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Dale of Norway Svale (50% cotton / 40% viscose / 10% silk; 114 yards [104 meters] / 50 grams): 2 balls #2846 copper")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One pair straight needles size US 4 "), _c('br'), _vm._v("(3.5 mm)"), _c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 4 (3.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Crochet hook size US E/4 (3.5 mm); stitch markers; cable needle (cn); 120 size 8/0 beads in coordinating color; wire beading needle; needle-nose pliers (for crushing off misshapen beads); waste yarn in contrasting color")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("23 sts and 30 rnds = 4\" (10 cm) in Stockinette stitch (St st) Beaded Twist Stitch Chart measures approximately 1"), _c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("8")])]), _c('span', {
    staticClass: "char-style-override-23",
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "char-style-override-23",
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("\" wide")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "boxPleats"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Prepare Beads"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Thread yarn through wire beading needle, then thread half of beads onto yarn. Keep pushing beads down yarn until they are required. Thread other half of beads onto second ball of yarn to use for second Glove, as you will not want to have to restring when you need to start a new ball. For more information, ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("see page 135")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Glove")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With straight needles and Long-Tail CO (see page 136), CO 52 sts. Begin St st, beginning with a WS row and slipping last st of each row purlwise. Work even for 7 rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (RS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K5, transfer next 8 sts onto 2 dpns (4 sts each), fold second dpn forward towards left-hand needle so that RS’s are together, and fold first dpn towards second dpn so that WS’s are together (you will ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have 3 layers arranged accordion-style, in the following ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("order: first dpn, second dpn, left-hand needle), then [k3tog (1 st from each needle)] 4 times, place next 8 sts onto 2 dpns [4-4], fold second dpn back towards left-hand needle so that WS’s are together, and fold first dpn towards second dpn so that RS’s are together (the order is reversed from the first pleat: left-hand needle, second dpn, first dpn), then [k3tog (1 st from each needle)] 4 times, knit to end–36 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, p1-tbl; repeat from * to last 2 sts, k2."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P2, *k1-tbl, p1; repeat from * to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Repeat last 2 rows once.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "BoxPleatsChart.eps",
      "src": "images/beadedStitchChart.jpg",
      "width": "400"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hand")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts to 4 dpns; divide evenly.  Join for ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("working in the rnd; place marker (pm) for beginning")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of rnd.")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [Note: Needles 1 and 2 hold the sts for the back of the hand, and Needles 3 and 4 hold the sts for the palm.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K2, M1L, [k3, M1L] 5 times, k4, M1L, [k4, M1L] 3 times, k3–46 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K7, pm, work Beaded Twist Stitch Chart across next 10 sts, pm, knit to end. Work even for 1 rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work 24 sts, pm for Thumb, M1L, k2, M1R, pm, knit to end–48 sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work to Thumb marker, slip marker (sm), M1L, knit to next marker, M1R, sm, knit to end–50 sts. Repeat Increase Rnd 2 every 3 rnds 4 times–58 sts. Work even for 1 rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 24 sts, transfer next 14 sts to waste yarn for Thumb, CO 2 sts over gap, knit to end–46 sts. Work even until Chart is complete.")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("BO 2 sts purlwise, *slide bead up close to needle, BO next 3 sts purlwise; repeat from * to last 2 sts, slide bead up close to needle, BO remaining sts purlwise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns, being careful not to twist sts. Rejoin yarn; pick up and knit 2 sts from sts CO over gap–16 sts. Join for working in the rnd; pm for beginning of rnd. Work even in St st for 3 rnds. BO all sts purlwise."), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Left Glove")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With straight needles and Long-Tail CO, CO 52 sts. Begin St st, beginning with a WS row and slipping last st of each row purlwise. Work even for 7 rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (RS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K23, work first and second pleat as for Right Glove over next 24 sts, knit to end–36 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K2, *p1-tbl, k1; repeat from * to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*P1, k1-tbl; repeat from * to last 2 sts, p2. Repeat last 2 rows once.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hand")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts to 4 dpns as for Right Glove. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: terms for \"palm\" and \"back of hand\" are reversed.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K3, M1L, [k4, M1L] 3 times, k5, M1L, [k3, M1L] 5 times, k1–46 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K29, pm, work Beaded Twist Stitch Chart across next 10 sts, pm, knit to end. Work even for 1 rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K20, pm for Thumb, M1L, k2, M1R, pm, work to end–48 sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work to Thumb marker, sm, M1L, knit to next marker, M1R, sm, work to end–50 sts. Repeat Increase Rnd 2 every 3 rnds 4 times–58 sts. Work even for 1 rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K20, transfer next 14 sts to waste yarn for Thumb, CO 2 sts over gap, work to end–46 sts remain. Complete as for Right Glove.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Charts",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "BoxPleats325.tiff",
      "height": "230",
      "src": "images/BoxPleats325_fmt.jpg",
      "width": "198"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends. Block Gloves lightly. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Button Loops (make 2)")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Using yarn with pre-strung beads and crochet hook, work a beaded crochet chain as follows: Make a slip knot, leaving a long tail, and place it on crochet hook. [Slide bead up close to hook, then holding tail end of yarn in left hand, take hook under ball end of yarn from front to back; draw yarn on hook back through previous st on hook to form new st] 8 times. Fasten off and tie tails together tightly with a square knot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Buttons (make 2)")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Tie knot in one end of 6\" strand of yarn. Thread 16 beads onto yarn. Tie another knot after the last bead, so that beads are tightly pushed together. "), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Tie strand of beads in a knot, then tie tails together with a square knot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Attach Button Loop to ribbing at wrist, so that Loop is on back side of Glove. Attach Button opposite Button Loop, on palm side of Glove. Repeat for second Glove.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('a', {
    attrs: {
      "id": "brunnhilde"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Brunhilde111.tiff",
      "height": "479",
      "src": "images/Brunhilde111_fmt.jpg",
      "width": "396"
    }
  })])]), _c('a', {
    attrs: {
      "id": "brunnhilde"
    }
  })]), _c('a', {
    attrs: {
      "id": "brunnhilde"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-18",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Brünnhilde")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("These opera-length gloves take their name from one of the Valkyries in the second opera, "), _c('i', [_vm._v("Die Walküre")]), _vm._v(", of Wagner’s Ring Cycle. The traveling twisted-stitch pattern is inspired by a beautiful German style of knitting, and the gloves are decorated with "), _c('span', {
    staticClass: "Introduction-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xmlns": "http://www.w3.org/1999/xhtml"
    }
  }, [_vm._v("nupps")]), _vm._v("—decorative nodes created by making five stitches out of one, then decreasing back to one stitch on the following row—which are typically used in Estonian lace. To keep the knitting stress-free, the entire hand is charted so you can easily see how the stitchwork flows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7¼\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Inca Gold Collection Warani (50% Suri alpaca / 50% Merino wool; 110 yards [100 meters] / 50 grams): 3 skeins #100 natural")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 6 (4 mm) Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Crochet hook size US C/2 (2.75 mm) (optional); stitch markers; cable needle (cn); tapestry needle; waste yarn in contrasting color")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("22 sts and 29 rnds = 4\" (10 cm) in Stockinette stitch (St st)")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Left Glove")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Forearm")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO (see page 136), CO 55 sts, divide among 4 needles [14-14-14-13]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. Begin Chart A. Work even, working decreases as indicated, until Chart is complete–35 sts remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Wrist and Hand"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to Chart B. Work even, working increases and decreases as indicated, until Rnd 80 is complete. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Be sure to reposition beginning of rnd marker on Rnds 70 and 72, as indicated in Chart Notes.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 81:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work to blue line on Chart B, pm for Thumb, change to Left Thumb Chart, work Rnd 1, pm, return to Chart B, work to end. Work even, working Thumb Chart between Thumb markers, until Rnd 96 is complete–48 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 97: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work to first Thumb marker, transfer next 12 sts (8 Thumb sts and next 4 hand sts) to waste yarn for Thumb, removing Thumb markers, CO 4 sts over gap, work to end–40 sts remain. Work even until Chart B is complete. Work even in St st until piece is long enough to reach base of fingers, ending 2 sts before beginning of rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Divide for Fingers"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Redistribute sts so that last 20 sts worked are on Needle 3 for back of hand, and remaining 20 sts are on Needle 1 for palm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Use a piece of waste yarn threaded on a tapestry needle to hold the sts for each Finger.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer last 5 sts from Needle 3 and first 5 sts from Needle 1 to waste yarn–10 sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Ring Finger: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 4 sts from each of Needles 3 and 1 to waste yarn–8 sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Middle Finger:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Transfer next 5 sts from each of Needles 3 and 1 to waste yarn–10 sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Index Finger:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Transfer remaining 6 sts from each of Needles 3 and 1 to waste yarn–12 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns. K5, CO 2 sts over gap between Pinkie and Ring Finger, k5–12 sts. Join for working in the rnd; pm for beginning of rnd. Work in St st until piece is long enough to cover Pinkie (approximately 16 rnds).")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * around–6 sts")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ring Finger and Middle Finger"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("W")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("orking one Finger at a time, transfer sts from waste yarn to dpns. Rejoin yarn; pick up and knit 2 sts from sts CO between previous Finger and current Finger, k4 for Ring Finger (k5 for Middle Finger), CO 2 sts over gap between current Finger and next Finger, k4 for Ring Finger (k5 for Middle Finger)–12 sts for Ring Finger (14 for Middle Finger). Join for working in the rnd; pm for beginning of rnd. Work in St st until piece is long enough to cover finger ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("(approximately 20 rnds for Ring Finger; 21 rnds for")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Middle Finger).")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Complete as for Pinkie–6 sts remain for Ring Finger (7 sts for Middle Finger).")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger and Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Working one Finger at a time, transfer sts from waste yarn to dpns. Rejoin yarn; pick up and knit 2 sts from sts CO between previous Finger and current Finger for Index Finger (4 sts from sts CO over gap for Thumb), k12–14 sts for Index Finger (16 sts for Thumb). Join for working in the rnd; pm for beginning of rnd. Work in St st until piece is long enough to cover finger (approximately 19 rnds for Index Finger; 17 rnds for Thumb). Complete as for Pinkie–7 sts remain for Index Finger (8 sts for Thumb)."), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Glove")]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Glove to beginning of Thumb Shaping.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 81: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work to red line on Chart B, pm for Thumb, change to Right Thumb Chart, work Rnd 1, pm, return to Chart B, work to end. Work even, working Thumb Chart between Thumb markers, until Rnd 96 is complete–48 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 97:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work to 4 sts before first Thumb marker, transfer next 12 sts (next 4 hand sts and 8 Thumb sts) to waste yarn for Thumb, removing Thumb markers, CO 4 sts over gap, work to end–40 sts ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("remain. Work even in St st until piece is long enough")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to reach base of fingers, ending after st #15 of last rnd. Complete as for Left Glove.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends, using tails from rejoined yarn to close any gaps at the base of the Fingers. Block Gloves to even out sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Brunhilde96.tiff",
      "height": "240",
      "src": "images/Brunhilde96_fmt.jpg",
      "width": "198"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "760",
      "src": "images/brunHildeCharta.jpg",
      "width": "189"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "588",
      "src": "images/brunHildeChartb.jpg",
      "width": "573"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Charts",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "1.11em"
    }
  }), _c('span', {
    staticClass: "Chart-Title",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('b', [_vm._v("Chart Notes")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Charts",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Charts",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-body-copy",
    staticStyle: {
      "font-size": "1.14em"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "1.14em"
    }
  }, [_vm._v(". Chart A shows one 11-st repeat (worked 5 times around), and is worked to the wrist. Chart B shows the entire rnd, and is worked from the wrist to the base of the fingers. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Charts",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "1.14em"
    }
  }, [_vm._v("2. The Nupp sts in Charts A and B are worked over 2 rnds. You will increase from 1 st to 5 sts on the first rnd, then decrease back to 1 st on the following rnd. If you find it difficult to purl the 5 sts together, you might want to use a crochet hook to pull the working yarn through the sts. ")]), _vm._v(" "), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "1.14em"
    }
  }, [_c('br'), _vm._v("3. In Chart B, there are a number of twist sts along the right-hand edge of the Chart that are shaded in yellow. These twists are begun 1 st before the beginning of the rnd. In each case, there is a corresponding yellow box at the end of the chart to indicate that the last st was worked with the first st in the next rnd. On Rnds 53, 67, and 74, once the twist has been worked, replace the beginning of rnd marker in its original position. On Rnds 70 and 72, the beginning of rnd marker will be repositioned in front of the twist sts. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Charts",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Charts",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "1.14em"
    }
  }, [_vm._v("4. When beginning the Thumbs, you will work a M1 between a pair of sts; these sts are indicated by a blue line for the Left Thumb and a red line for the Right Thumb.")]), _c('span', {
    staticClass: "Tool-List-body-copy-italic",
    staticStyle: {
      "font-size": "1.14em"
    }
  }), _c('span', {
    staticClass: "Tool-List-body-copy-italic char-style-override-2",
    staticStyle: {
      "font-size": "1.14em"
    }
  }, [_vm._v("[Note: Work the Left Thumb Chart for the Left Glove only, and the Right Thumb Chart for the Right Glove only.]")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "1.14em"
    }
  }, [_vm._v(" On Rnd 81 of Chart B, work to the center of the Thumb line, place marker (pm) for the beginning of the Thumb, work the first rnd of the Thumb Chart, pm for the end of the Thumb, then continue to the end of the rnd. You will continue to work increases as indicated in the Thumb Chart, until the Thumb Chart is complete. At this point, the Thumb sts will be transferred to waste yarn and set aside. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "BrunhildeChartB.eps",
      "src": "images/brunsHilde_b.jpg",
      "width": "420"
    }
  })])])]), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "brunnhilde"
    }
  }), _c('a', {
    attrs: {
      "id": "ceangaltas"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "GoldenBraclets9.tiff",
      "height": "479",
      "src": "images/GoldenBraclets9_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "ceangaltas"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Ceangaltas")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("The name of this mitten is the Irish word for bond or tie, reflecting the nature of the knotwork design employed. The textured tweed yarn summons the image of rough-hewn stone, like the carved pillars and crosses of medieval Irish sculpture. The knotwork is formed from I-cord, which is begun around the cuff edge, then encircles the wristand morphs into the knot. The split cuff and pointy tip of the mittens are reminiscent of the shape of armored gauntlets.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Women’s Small (Medium, Large)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7¼ (7¾, 8¼)\" "), _c('br'), _vm._v("circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Jo Sharp Silkroad DK Tweed (85% wool / 10% silk / 5% cashmere; 147 yards (134 meters) / 50 grams): 2 balls #403 emerald (MC); 1 ball #400 ambrosia (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One pair straight needles size US 5 (3.75 mm)"), _c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 5 (3.75 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch marker; waste yarn in contrasting color; stitch holder; straight pins ")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("22 sts and 32 rnds = 4\" (10 cm) in Stockinette stitch (St st)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Mitten")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With straight needles and MC, CO 38 (40, 44) sts. Begin St st beginning with a WS row. Work even until piece measures approximately 3¼\" from the beginning, ending with a RS row, CO 2 sts at end of last row–40 (42, 46) sts. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hand")]), _c('span', {
    staticClass: "char-style-override-16",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer 2 CO sts and next 9 (10, 11) sts to Needle 1, next 10 (11, 12) sts to Needle 2, next 10 (10, 11) sts to Needle 3, and last 9 (9, 10) sts to Needle 4. ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Join for working in the rnd, k9 (9, 10), across Needle 4; place marker (pm) for new beginning of rnd. Slip second CO st from Needle 1 to Needle 4. Continue in St st until piece measures approximately 2¾\" from end of Cuff.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K21 (22, 24), change to waste yarn and k8, slip these 8 sts back to left-hand needle, change to working yarn, knit these 8 sts again, knit to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work even until piece measures approximately 6¼ (6¼, 6½)\" from end of Cuff.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Mitten Top"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K1, ssk, knit to last 3 sts of next needle, k2tog, k1; repeat from * around–36 (38, 42) sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br'), _vm._v("Repeat last 2 rnds 7 (7, 8) times–8 (10, 10) sts remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Size Small Only"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, k2tog, k1; repeat from * around–6 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Size Medium And Large"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, dcd, k1; repeat from * around–6 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb (All sizes)")]), _c('span', {
    staticClass: "char-style-override-16",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Carefully remove waste yarn from Thumb sts and place bottom 8 sts and top 9 sts onto 2 dpns, being careful not to twist sts. Rejoin yarn to bottom sts, pick up and knit 2 sts at side of Thumb Opening, knit across 8 bottom sts, pick up and knit 2 sts at other side of Thumb Opening, knit across 9 top sts–21 sts. Redistribute sts evenly among 3 dpns. Join for working in the rnd; pm for beginning of rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K1, k2tog, k6, ssk, k2tog, k7, ssk (last st of this rnd together with first st of next rnd)–17 sts remain. Work even in St st until piece is long enough to cover thumb (approximately 18 more rnds)."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to last st, k1–9 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Left Mitten"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Right Mitten to Thumb Opening. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K31 (33, 37), change to waste yarn and k8, slip these 8 sts back to left-hand needle, change to working yarn, knit these 8 sts again, k1. Complete as for Right Mitten.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-16",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Block mittens.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I-Cord Trim"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With dpn and A, CO 3 sts. With WS of one Mitten facing, beginning at side edge of Cuff next to 2 CO sts, work 3-st Applied I-Cord (see page 138) down side edge of Cuff, along CO edge, then up other side edge and across 2 CO sts where Cuff is joined, pick up and knit 1 st–4 sts. Continue working 4-stitch I-Cord (unattached) until unattached portion of I-Cord measures approximately 20\". Cut yarn and transfer sts to st holder. Wrap I-Cord around wrist to center back of hand and pin to secure. Twist I-Cord into knotwork design as illustrated, using pins to hold it in place as you manipulate it. Wrap end of I-Cord around other side of wrist, back to end of Cuff split. With A, tack down I-Cord, beginning from the attached end and working in the same direction in which it was wrapped, making sure that sts do not show on RS, and that I-Cord lies flat. Adjust length of I-Cord if necessary. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off. Sew end of I-Cord neatly to beginning.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "CeangaltasIllustration.eps",
      "src": "images/CeangaltasIllustration_fmt.png"
    }
  })])])]), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "ceangaltas"
    }
  }), _c('a', {
    attrs: {
      "id": "chevalier"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Chevalier5.tiff",
      "height": "479",
      "src": "images/Chevalier5_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "chevalier"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-24",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Chevalier")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("I think the dark bouclé yarn and the kilt straps at the wrists of these mittens evoke a military air; they make me think of fur-trimmed hats and the trappings of cavalry. These mittens are also a good example of how a knitted item can be embellished with findings originally intended for sewn items. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "chevalier"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Women’s Medium (Large)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7¾ (8¼)\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Garnstudio Eskimo (100% wool; 55 yards [50 meters] / 50 grams): 2 balls #14 (MC)"), _c('br'), _vm._v("Garnstudio Puddel (64% mohair / 20% wool / 16% viscose; 55 yards [50 meters] / 50 grams): 1 ball #8 (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 10½ (6.5 mm)"), _c('br'), _vm._v("One set of five double-pointed needles size US 11 (8 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; waste yarn; 2 leather or vinyl kilt straps; sewing thread and needle")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("11½ sts and 16 rnds = 4\" (10 cm) in Reverse Stockinette stitch (Rev St st) using A and smaller needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("11½ sts and 16 rnds = 4\" (10 cm) in Stockinette stitch (St st) using MC and larger needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Mittens (both alike)")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "chevalier"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With smaller needles, Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(" and A, CO 24 (26) sts, divide among 4 needles [6-6-6-6 (6-7-6-7)]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd.")]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K1, p1; repeat from * to end. Begin Rev St st (purl every rnd). Work even for 7 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[P10 (11), p2tog] twice–22 (24) sts remain. Work even for 7 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[P9 (10), p2tog] twice–20 (22) sts remain. Work even for 2 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hand")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to larger needles and MC. Begin St st (knit every rnd)."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[K10 (11), M1L] twice–22 (24) sts. Work even for 2 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K10 (11), place marker (pm) for Thumb, M1R, k1, M1L, pm, k11 (12)–24 (26) sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit to marker, slip marker (sm), M1R, k3, M1L, sm, knit to end–26 (28) sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to marker, sm, M1R, k5, M1L, sm, knit to end–28 (30) sts. Work even for 1 rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K10 (11), transfer next 7 sts to waste yarn for Thumb, removing Thumb markers, CO 1 st over gap, knit to end–22 (24) sts remain. Work even until Mitten measures approximately 7¼ (7½)\" from end of Cuff, or until tips of fingers are just covered."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * to end–11 (12) sts remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * to last 1 (0) st, k1 (0)–6 sts remain. Cut yarn, leaving a 6\" tail. Draw tail through remaining sts, pull tight and fasten off. Weave in end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to larger needles. Rejoin yarn; pick up and knit 2 sts from sts CO over Thumb gap (1 st on either side)–9 sts. Divide sts among 3 needles. Join for working in the rnd; pm for beginning of rnd. Begin St st; work even until Thumb is just covered (approximately 9 rnds).")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to last st, k1–5 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off. Weave in end. Use tail from rejoined yarn to close any gaps around Thumb join.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in remaining ends. Choose a left and right Mitten, place palm side down with thumbs facing each other, and position a kilt strap on the back of each hand at the point where Cuff meets Hand. Make sure the end that goes through buckle points to outside of Hand. With sewing needle and thread, stitch each end of 2-part strap in place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "KnittingBook4.tiff",
      "height": "230",
      "src": "images/KnittingBook4_fmt.jpg",
      "width": "198"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "driver"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Driver532.tiff",
      "height": "479",
      "src": "images/Driver532_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "driver"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Driver")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("I often like to reinterpret in knitting a form that is typically created using another method. These fingerless gloves have the ubiquitous leather driving glove as their inspiration. The adjustable wristband and the knuckle and back cutouts mimic their muse. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7¼\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Rowan Scottish Tweed DK (100% wool; 123 yards [113 meters] / 50 grams): "), _c('br'), _vm._v("1 ball #19 peat")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One pair straight needles size US 3 "), _c('br'), _vm._v("(3.25 mm)"), _c('br'), _vm._v("One pair straight needles size US 4 "), _c('br'), _vm._v("(3.5 mm)"), _c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 4 (3.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; waste yarn in contrasting color; tapestry needle; two pair 1\" D-rings; safety pins")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("22 sts and 30 rnds = 4\" (10 cm) in Stockinette stitch (St st) using larger needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note"), _c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The ribbed Wristband at the lower edge of the Glove is worked first, then the stitches for the hand are picked up and knit from the Wristband. The piece is worked flat until the cutout on the back of the hand is completed, then it is joined and worked in the round. Use the Backward Loop CO (see page 136) to CO sts over spaces–– thumbholes, fingers, knuckle cut-outs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Wristband (make 2)")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-25",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With smaller needles, CO 7 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 1 (RS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [K1, p1] 3 times, k1."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [P1, k1] 3 times, p1.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Repeat Rows 1 and 2 until piece measures approximately")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" 9½\" from the beginning, ending with a WS row.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Wristband"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 1 (RS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ssk, k1, p1, k1, k2tog–5 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P2, k1, p2."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Ssk, p1, k2tog–3 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P1, k1, p1."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 5:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Dcd–1 st remains. Cut yarn, leaving a 6\" tail. Draw through remaining st, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Glove"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Lay Wristband flat on a table. With RS of band facing, and pointed end of Wristband on left, place safety pins on upper edge as follows: one pin 1¼\" from right edge (flat end), and another pin 5½\" from first pin. With larger straight needles, pick up and knit 34 sts between pins.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Setup Row (WS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, p7, place marker (pm), p18, pm for Thumb, p7, k1. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Markers mark sides of the hand.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 1: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K1, ssk, k4, M1R, k1, slip marker (sm), k1, M1L, k16, M1R, k1, sm, k1, M1L, k4, k2tog, k1–36 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 2 and all WS Rows: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K1, purl to last st, k1."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 3 and 5: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K1, ssk, knit to last 3 sts, k2tog, k1–32 sts remain after Row 5.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 7:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to Thumb marker (first marker), sm, M1R, k2, M1L, knit to end–34 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 9:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, M1L, knit to Thumb marker, sm, M1R, k4, M1L, knit to last 2 sts, M1R, k2–38 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 11:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, M1L, knit to last 2 sts, M1R, k2–40 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 13:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, M1L, knit to Thumb marker, sm, M1R, k6, M1L, knit to last 2 sts, M1R, k2–44 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 15:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to Thumb marker, sm, M1R, k8, M1L, knit to end, CO 2 sts–48 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Redistribute sts and markers on 4 dpns for working in the rnd as follows: place last 11 sts of row on Needle 1, next 10 sts on Needle 2, next 18 sts on Needle 3, and remaining 9 sts of row on Needle 4. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Needles 4 and 1 hold the sts for the back of the hand, and Needles 2 and 3 hold the palm and Thumb sts. The marker between Needles 1 and 2 is the new beginning of rnd marker.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Join for working in the rnd; knit to beginning of rnd marker."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit to Thumb marker, sm, M1R, k10, M1L, knit to end–50 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 4 and 5:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 6:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to Thumb marker, sm, M1R, k12, M1L, knit to end–52 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 7: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 8: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit to Thumb marker, slip next 14 sts to waste yarn, removing Thumb marker, CO 2 sts over gap, knit to end–40 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 9-12: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Knuckle Cutouts"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 13: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[K1, BO 3] 3 times, k2, BO 3, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 14: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit, CO 3 sts over each gap."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 15-19: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit, removing marker after last rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Divide for Fingers"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer all sts from Needle 4 to Needle 1 for back of hand, and all sts from Needle 3 to Needle 2 for palm–20 sts on each needle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Use a piece of waste yarn threaded on a tapestry needle to hold the sts for each Finger.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Transfer first 4 sts from Needle 1 and last 4 sts from Needle 2 to waste yarn–8 sts. "), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ring Finger: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 4 sts from each of Needles 1 and 2 to waste yarn–8 sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Middle Finger: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 5 sts from each of Needles 1 and 2 to waste yarn–10 sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger:")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer remaining 7 sts from each of Needles 1 and 2 to waste yarn–14 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie")]), _c('span', {
    staticClass: "char-style-override-16",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns. K4 (back of hand sts), CO 2 sts over gap between Pinkie and Ring Finger, k4 (palm sts)–10 sts. Join for working in the rnd; pm for beginning of rnd. Knit 4 rnds. BO all sts loosely enough to fit finger through.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ring Finger and Middle Finger"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Working one Finger at a time, transfer sts from waste yarn to dpns. Rejoin yarn; pick up and knit 2 sts from sts CO between previous Finger and current Finger, k4 for Ring Finger (k5 for Middle Finger), CO 2 sts over gap between current Finger and next Finger, k4 for Ring Finger (k5 for Middle Finger)–12 sts for Ring Finger (14 sts for Middle Finger). Join for working in the rnd; pm for beginning of rnd. Knit 4 rnds for Ring Finger (5 rnds for Middle Finger). BO all sts loosely enough to fit finger though."), _c('br'), _c('br')]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger and Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Working one Finger at a time, transfer sts from waste yarn to dpns. Rejoin yarn; pick up and knit 2 sts from sts CO between previous Finger and current Finger (or from sts CO over gap for Thumb), k14–16 sts. Join for working in the rnd; pm for beginning of rnd. Complete as for Middle Finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Left Glove"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Lay Wristband flat on a table. With RS of Wristband facing, and pointed end of Wristband on right, place safety pins on upper edge as follows: one pin 1¼\" from left edge (flat end), and another pin 5½\" from first pin. With larger straight needles, pick up and knit 34 sts between pins.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Setup Row (WS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, p7, pm, p18, pm, p7, k1. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Markers mark sides of the hand.]")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Row 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, ssk, k4, M1R, k1, sm, k1, M1L, k16, M1R, k1, sm, k1, M1L, k4, k2tog, k1–36 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 2 and all WS Rows:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, p to last st, k1."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 3 and 5: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K1, ssk, knit to last 3 sts, k2tog, k1–32 sts after Row 5.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-25",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 7:")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to 2 sts before second marker, place marker for Thumb, M1R, k2, M1L, sm, knit to end–34 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 9:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, M1L, knit to Thumb marker, sm, M1R, k4, M1L, sm, knit to last 2 sts, M1R, k2–38 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 11: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K2, M1L, knit to last 2 sts, M1R, k2–40 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 13:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, M1L, knit to Thumb marker, sm, M1R, k6, M1L, sm, knit to last 2 sts, M1R, k2–44 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 15:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to Thumb marker, sm, M1R, k8, M1L, sm, knit to end, CO 2 sts–48 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Redistribute sts on 4 dpns for working in the rnd as follows: place last 11 sts of row on Needle 1, next 18 sts on Needle 2, next 10 sts on Needle 3, and remaining 9 sts of row on Needle 4. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Needles 4 and 1 hold the sts for the back of the hand, and Needles 3 and 2 hold the palm and Thumb sts. The marker between Needles 1 and 2 is the new beginning of rnd marker.] ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Join for working in the rnd; knit to "), _c('br'), _vm._v("beginning of rnd marker."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit to Thumb marker, sm, M1R, k10, M1L–50 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 4 and 5:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 6:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to Thumb marker, sm, M1R, k12, M1L–52 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 7: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 8:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to thumb marker, slip next 14 sts to waste yarn, removing Thumb marker, CO 2 sts over gap and join to beginning of rnd–40 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 9-12: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Knuckle Cutouts"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 13: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K3, BO 3, k2, [BO 3, k1] 3 times, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 14: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit, CO 3 sts over each gap."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 15-19:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit, removing marker after last rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Divide for Fingers"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Right Glove, reversing order of Fingers, beginning with Index Finger and working Thumb last.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-16",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Use tails from rejoined yarns to close any holes around Fingers and Thumb. Weave in ends. With WS of Wristband facing, place flat sections of one pair of D-rings on flat end of Wristband. Fold end to WS and sew in place, being careful not to let sts show on RS. Repeat for other Glove.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Driver537.tiff",
      "height": "230",
      "src": "images/Driver537_fmt.jpg",
      "width": "198"
    }
  })])])]), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "driver"
    }
  }), _c('a', {
    attrs: {
      "id": "eveningLight"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "EveingLight40.tiff",
      "height": "479",
      "src": "images/EveingLight40_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "eveningLight"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-7",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Evening Light")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("In the beaded versions of these fingerless gloves, the metallic beads glimmer softly against the dark colors of the variegated yarn, like stars that begin to appear in the sky at dusk. The “plain” versions are worked without beads and can be machine washed (as long as you use machine-washable yarn). All of these gloves are worked from side to side in Garter stitch, like the pulse-warmers of Norway, but with a short-rowed thumb gore, so they can be worn higher on the hand than the pulse-warmers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "eveningLight"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Children’s (Women’s Medium short length, Women’s Large short length, Women’s Medium long length, Women’s Large long length, Men’s Medium, Men’s Large)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 5½")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" (6, 6")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("½")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(", 6, 6½, 8, 9)\" circumference; approximately 5 (5¾, 5¾")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(", 8¼, 8¼, 7, 7½)\" long"), _c('br')]), _c('span', {
    staticClass: "char-style-override-26",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note: Glove stretches appreciably when worn.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Mountain Colors Bearfoot (60% superwash")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" wool / 25% mohair / 15% nylon; 350 yards [318 meters] / 100 grams): 1 hank all sizes. Children’s version shown in rich red; Women’s short length shown in elderberry; Women’s long length shown in juniper; and Men’s version shown in bark brown.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One pair straight needles size US 4 "), _c('br'), _vm._v("(3.5 mm)"), _c('br'), _vm._v("One straight or double-pointed needle (dpn) size US 4 (3.5 mm), for Three-Needle BO"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch marker; removable marker; stitch holder. For Women’s Versions only: 250 size 6/0 beads; wire beading needle; needle-nose pliers (for crushing off misshapen beads)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("24 sts and 48 rows = 4\" (10 cm) in Garter stitch (knit every row)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_c('br'), _vm._v("Notes")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Beaded (Women’s) Versions Only: Beads are placed on WS rows, between sts, so that they show on the RS. Note that charts show WS rows only, and should be followed from left to right. RS rows are not charted, as they are plain; knit all RS rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Slip first st of every row purlwise with yarn in front (do this at thumb edge also). The slipped st will be included in the st count, but will not be mentioned in the instructions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("If you would like to make the Women’s versions omitting the beads, simply work the appropriate number of plain rows in place of the charts")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_c('br'), _vm._v("Three-Needle BO")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Place the stitches to be joined onto two same-size needles; hold the pieces to be joined with the right sides facing each other and the needles parallel, both pointing to the right. Holding both needles in your left hand, using working yarn and a third needle the same size or one size larger, insert the third needle into the first stitch on the front needle, then into the first stitch on the back needle; knit these two stitches together; *knit the next st from each needle together (you now have two stitches on the right-hand needle); pass the first stitch over the second stitch to BO 1 stitch. Repeat from * until 1 stitch remains on the third needle. Cut the yarn, leaving a 6\" tail. Draw through the remaining st, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('br')])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "eveningLight"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Beaded (Women’s) Versions"), _c('br'), _c('br')]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Prepare Beads")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Thread yarn through wire beading needle. Thread beads onto yarn, adding a few extra beads in case you find any that are misshapen and must be crushed off. For more information, see ")])]), _c('a', {
    attrs: {
      "href": "#/section#selectingMaterials"
    }
  }, [_vm._v("page 135")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    }
  }, [_c('br'), _vm._v("Left Glove"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("With Long-Tail CO (see page 136), CO 30 (35, 35, 50, 50, 42, 45) sts, leaving a very long tail. Begin Garter st (knit every row), slipping first st of every row purlwise wyif. Work even for 33 (35, 39, 0, 2, 49, 55) rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Women’s Medium Long Length, Women’s Large Long Length Only")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Begin Chart")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-28",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (WS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work Long Version Chart across 25 sts, working Chart from left to right, place marker (pm), knit to end. Work even until Chart is complete, knitting all RS rows and ending with a WS row. ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work even for 0 (2) rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Sizes")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Short Row Thumb Shaping")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 1 (RS) and 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 9 (11, 11, 11, 11, 14, 15) sts and place on holder, k4, wrp-t, knit to end–21 (24, 24, 39, 39, 28, 30) sts remain. "), _c('br'), _vm._v("Place removable marker on Row 1 to indicate RS of work."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 3 and 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work 6 sts, wrp-t, knit to end. "), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 5 and 6: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 8 sts, wrp-t, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 7 and 8: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 10 sts, wrp-t, knit to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Adult Sizes Only")]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 9 and 10: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 12 sts, wrp-t, knit to end. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Men’s Sizes Only")]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 11 and 12:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work 14 sts, wrp-t, knit to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Men’s Size Large Only")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 13 and 14:")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 16 sts, wrp-t, knit to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Sizes"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next 2 Rows:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit across all 21 (24, 24, 39, 39, 28, 30) sts. Repeat Rows 8-3 (10-3, 10-3, 10-3, 10-3, 12-3, 14-3), working rows in reverse order."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next 2 Rows:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work 4 sts, wrp-t, knit to end, knit across sts from holder–30 (35, 35, 50, 50, 42, 45) sts. Work even for 32 (5, 7, 1, 3, 48, 54) rows, ending with a WS (RS, RS, RS, RS, WS, WS) row.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Women’s Medium Short Length, Women’s Large Short Length Only")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _c('br')]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Begin Chart")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-28",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (WS)")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(": Work Short Version Chart across 32 sts, working Chart from left to right, pm, work to end. Work even until Chart is complete, knitting all RS rows and ending with a WS row, removing marker on last row. Work even for 4 (6) rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Women’s Medium Long Length, Women’s Large Long Length Only")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Work entire Long Version Chart again."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-28",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (RS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work even for 0 (2) rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Sizes")]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Leave sts on needle; do not cut yarn.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Join Side Seam")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("With RS facing, using separate needle, pick up and knit 29 (34, 34, 49, 49, 41, 44) sts from CO row, using tail from CO. Fold Glove so that RS")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-29",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("’")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("s are together, and join live sts and picked-up sts using Three-Needle BO "), _c('a', {
    attrs: {
      "href": "#/section#eveningLight"
    }
  }, [_vm._v("(see page 56)")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.38em"
    }
  }, [_c('br'), _vm._v("Right Glove")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Sizes Except Women’s Medium Short Length and Women’s Large Short Length")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Glove.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Women’s Medium Short Length, Women’s Large Short Length Only")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("With Long-Tail CO, CO 35 sts, leaving a very long tail. Begin Garter st, slipping first st of every row purlwise wyif. Work even for 4 (6) rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Begin Chart")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (WS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work Women’s Short Version Chart as for Left Glove until Chart is complete. Work even for 4 (6) rows. "), _c('br'), _vm._v("Work Short Row Thumb Shaping as for Left Glove. Work even for 34 (38) rows. Leave sts on needle; do not cut yarn. Join Side Seam as for Left Glove.")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "EveningLightChartsKey%5bConverted%5d.eps",
      "src": "images/knitBeadsKey.jpg",
      "width": "480"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "EveningLightPlain7.tiff",
      "height": "479",
      "src": "images/EveningLightPlain7_fmt.jpg",
      "width": "396"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "filigree"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Filigree_181.tif",
      "height": "479",
      "src": "images/Filigree_181_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "filigree"
    }
  }), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "filigree"
    }
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-18",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Filigree")])])]), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "filigree"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("These fingerless gloves, worked in an interestingly textured cotton yarn, have a casual insouciance \n\t\t\t\tthat makes them an ideal accessory for jeans, beachwear, clubwear—anything. These gloves are available in two different lengths (for long version, see left; for shorter version, see ")])]), _c('a', {
    attrs: {
      "href": "#/section#filigree"
    }
  }, [_vm._v("page 63")]), _vm._v("), and \n\t\t\t\tthe stitch pattern is reminiscent of the twisted\n\t\t\t\twirework of filigreed jewelry. The gloves are worked in the round to the thumbhole, then worked flat \n\t\t\t\tfor one pattern repeat, then rejoined into a round and completed. A bit of closed blanket stitch \n\t\t\t\tfinishes the thumbhole.")]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Women’s Small/Medium (Large)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 6½ (7¼)\" circumference, unstretched. ")]), _c('span', {
    staticClass: "char-style-override-30",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note: Glove will stretch appreciably when worn.")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Wrist-Length Version: Approximately 6\" long"), _c('br'), _vm._v("Elbow-Length Version: Approximately 11¼\" long")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Nashua Handknits Creative Focus Cotton (100% cotton; 93 yards [85 meters] / 50 grams): Wrist-Length Version: 1 (2) balls #027 McDearis Moors; Elbow-Length Version: 2 (3) balls #10 passion")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 6 (4 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch marker")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("20 sts and 24 rows = 4\" (10 cm) in Openwork Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Notes")]), _c('span', {
    staticClass: "char-style-override-18"
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("There are two versions of the Openwork Pattern used in this pattern; one for working in the round and one for working back and forth. Be sure to use the version specified in the text.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("To work a yo at the beginning of a row before a purl st, wrap yarn over right-hand needle from front to back, then between needles to front again, ready to purl the next stitch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stitch Pattern")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-18",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Openwork Pattern in-the-Rnd")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("(multiple of 4 sts; 4-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit, wrapping yarn around needle twice for each st."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *Slip next 4 sts to right-hand needle, dropping extra wraps, slip them back to left-hand needle, then k4tog, p4tog into these 4 sts; repeat from * to end. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.09em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Stitch count will be half of original number after this rnd.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, yo; repeat from * to end. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.09em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Original stitch count restored.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br'), _vm._v("Repeat Rnds 1-4 for Openwork Pattern in-the-Rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-18",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Openwork Pattern")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("(multiple of 4 sts; 4-row repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 1 (WS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Purl, wrapping yarn around needle twice for each st."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*Slip next 4 sts to right-hand needle, dropping extra wraps, slip them back to left-hand needle, then k4tog, p4tog into these 4 sts; repeat from * to end.")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [Note: Stitch count will be half of original number after this row.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 3: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*Yo, p1; repeat from * to end. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Original stitch count restored.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 4: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit."), _c('br'), _vm._v("Repeat Rows 1-4 for Openwork Pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "EveningLightLongVersionChart%5bConverted%5d.eps",
      "src": "images/Filingree626_fmt.jpg",
      "width": "209"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Fingerless Gloves (both alike)")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Wrist")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO "), _c('a', {
    attrs: {
      "href": "#/section#filigree"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", CO 32 (36) sts, divide evenly among 4 needles [8-8-8-8 (8-8-8-12)]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. Purl 1 rnd. Knit 1 rnd. Purl 1 rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to Openwork Pattern in-the-Rnd; work even for 16 rnds for Wrist-Length Version [48 rnds for Elbow-Length Version].")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening")]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-18",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to Openwork Pattern, dropping beginning of rnd marker; working back and forth, work even for 4 rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Palm")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to Openwork Pattern in-the-Rnd. Join for working in the rnd; pm for beginning of rnd. Work even for 8 rnds. Purl 1 rnd. Knit 1 rnd. Purl 1 rnd. BO all sts knitwise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Using Closed Blanket Stitch "), _c('a', {
    attrs: {
      "href": "#/section#filigree"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", sew around each thumb hole. Weave in ends.")])])]), _vm._v(" "), _c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "glaistig"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Glasgit_056.tif",
      "height": "479",
      "src": "images/Glasgit_056_fmt.jpg",
      "width": "395"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "glaistig"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Glaistig")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("These fingerless gloves are worked in an \n\t\t\t\told English lace pattern (collected by \n\t\t\t\tBarbara G. Walker in her phenomenal book \n\t\t\t\t"), _c('span', {
    staticClass: "Introduction-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xmlns": "http://www.w3.org/1999/xhtml"
    }
  }, [_vm._v(" A Treasury of Knitting Patterns")]), _vm._v(") and embellished \n\t\t\t\twith a picot bind-off. The ribbed cuffs are \n\t\t\t\tworked from side to side, and a yarn-covered \n\t\t\t\tbuckle is sewn to the end of each one. The \n\t\t\t\tgloves are named for a beautiful unearthly \n\t\t\t\tbeing from Scottish lore who dwells near water, \n\t\t\t\tand happens to be part goat (a pun on the \n\t\t\t\tcashmere content of the yarn).")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "glaistig"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7½\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Inca Gold Collection Baby Silk Cashmere (70% baby alpaca / 20% silk / 10% cashmere; 219 yards [200 meters] / 50 grams): 1 ball #1340 leaf green ")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One pair straight needles size US 4 "), _c('br'), _vm._v("(3.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Tapestry needle; two plastic center-bar buckles with 1¼\" (33 mm) inside diameter")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("20 sts and 32 rows = 4\" (10 cm) in English Mesh Lace from Chart"), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note")]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.38em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-31",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('b', [_vm._v("Knitted CO")])]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("You may use this method for your initial cast-on, or add stitches at the beginning of a row. When working an initial cast-on, make a slip knot and place it on the left-hand needle. *Knit the first stitch on the left-hand needle, draw up a new loop but do not drop the old loop from the left-hand needle, place the new loop on the left-hand needle. Repeat from * until the required number of stitches have been cast on. "), _c('br'), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    }
  }, [_c('br')])])]), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "glaistig"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.38em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuffs (make 2)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#filigree"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", CO 24 sts, leaving a long tail."), _c('br'), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 1 (WS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("P1, *p2, k2; repeat from * to last 3 sts, p2, slip 1 purlwise wyif."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, *k2, p2; repeat from * to last 3 sts, k2, slip 1 purlwise wyib. "), _c('br'), _vm._v("Repeat Rows 1 and 2 until piece measures approximately 9½\" from the beginning, ending with a WS row."), _c('br'), _vm._v("BO all sts in pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.38em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Fingerless Gloves (both alike)")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    }
  }, [_vm._v("With Long-Tail CO, CO 39 sts. Purl 1 row."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1.03em"
    }
  }, [_vm._v("Next Row (RS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    }
  }, [_vm._v("Begin English Mesh Lace Chart. Work even until piece measures approximately 5\" from the beginning, ending with a WS row."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1.03em"
    }
  }, [_vm._v("Picot BO:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    }
  }, [_vm._v(" BO 3 sts, *slip 1 st from right-hand needle back to left-hand needle, CO 2 sts using the Knitted CO, BO next 5 sts; repeat from * to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Block Glove pieces to approximately 7½\" wide by 5\" long. Do not block Cuffs. Sew side seams of Gloves for 2\" up from CO edge, and for 1¼\" down from BO edge, leaving approximately 1¾\" open for thumb.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Self-Covered Buckle (make 2) ")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cut a strand of yarn approximately 2 yards (1.8 meters) long. Fold in half and thread the two ends through a tapestry needle. To begin, fix strand to buckle by threading two free ends through loop at end of your doubled strand, around outer circle of buckle. Continue in Closed Blanket Stitch "), _c('a', {
    attrs: {
      "href": "#/section#filigree"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(" with doubled strand, packing sts very densely and tightly around outer circle of buckle, and cutting additional lengths of yarn as needed. Weave in ends on back of buckle. If desired, add a small dab of white glue where outer circle meets the center bar, and push yarn wraps together over any plastic that is showing. Using CO tail, sew buckle to CO edge of each Cuff by folding end of Cuff over center bar of buckle and stitching neatly on WS, making sure sts do not show on RS.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Measure approximately 6½\" (or your wrist circumference) from center of buckle and place marker. Position Cuff on Glove so that buckle is centered on back of hand. Cuff should wrap around wrist, thread through buckle and point to heel of hand, away from thumb. Making sure not to sew too tightly, sew Cuff to lower edge of Glove, from buckle to marker, easing in fullness of Glove, and ending approximately ¼\" before reaching buckle again. Weave in ends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "567",
      "src": "images/englishMeshLaceCharta.jpg",
      "width": "417"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "573",
      "src": "images/englishMeshLaceChartb.jpg",
      "width": "471"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "goldenBracelets"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "GoldenBraclets7.tiff",
      "height": "479",
      "src": "images/GoldenBraclets7_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "goldenBracelets"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-24",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Golden Bracelets")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("The Fair Isle band at the wrist of these gloves \n\t\t\t\tis designed to emulate the appearance of golden bracelets. The motif is inspired by the intricate \n\t\t\t\tcurvilinear shapes that decorated early medieval Celtic jewelry. The cuff below the bracelet is\n\t\t\t\tsubtly flared and has a picot edge. The gloves \n\t\t\t\tare worked in a fine Shetland wool, whose subtle heathering blends the various colors into the \n\t\t\t\tappearance of time-burnished gold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "goldenBracelets"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7½\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Jamieson’s Shetland Spindrift (100% pure Shetland wool; 115 yards [105 meters] "), _c('br'), _vm._v("/ 25 grams): 2 balls #140 rye (MC); "), _c('br'), _vm._v("1 ball each #232 blue lovat (A), #233 spagnum (B), #1160 scotch broom (C), and #429 old gold (D)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 1½ (2.5 mm)"), _c('br'), _vm._v("One set of five double-pointed needles size US 2 (2.75 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stitch markers; waste yarn in contrasting ")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("color (or use A, B, C, or D); tapestry needle")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("32 sts and 44 rnds = 4\" (10 cm) in Stockinette stitch (St st) using smaller needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("16 sts and 16 rnds = 2\" (5 cm) in Stockinette stitch over Fair Isle "), _c('br'), _vm._v("Chart using larger needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "goldenBracelets"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "1.33em"
    }
  }, [_c('br'), _c('br'), _vm._v("Left Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("With smaller needles, Long-Tail CO  ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/section#filigree"
    }
  }, [_vm._v("(see page136)")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" and MC, CO 64 sts, divide evenly among 4 needles [16-16-16-16]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd.")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    }
  }, [_vm._v(" [Note: Needles 1 and 2 hold the sts for the palm and Thumb, and Needles 3 and 4 hold the sts for the back of the hand.] ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Begin St st. Work even for 7 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Picot Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog, yo; repeat from * around. "), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to St st; work even for 14 rnds.")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Decrease Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K14, k2tog; repeat from * around–60 sts remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Begin Chart"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to larger needles. Begin Fair Isle Chart. Work even until Chart is complete, carrying colors not in use loosely up WS at beginning of Chart."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to smaller needles, MC, and St st. Work even for 4 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Shape Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K28, pm for Thumb, M1L, k2, M1R, pm, knit to end–62 sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit to first marker, M1L, knit to second marker, M1R, knit to end–64 sts. Work even for 2 rnds."), _c('br'), _vm._v("Repeat last 3 rnds 6 times, then repeat Increase Rnd 2 once–78 sts. Work even for 1 rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit to first marker, transfer next 20 sts to waste yarn for Thumb, CO 2 sts over gap, knit to end–60 sts remain. Work even in St st until piece is long enough to reach base of Pinkie (approximately 13 rnds), ending 7 sts before end of last rnd, removing all markers on last rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Divide for Fingers"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie:")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 14 sts [last 7 sts of rnd and first 7 sts of next rnd] to waste yarn, pm, CO 2 sts over gap, knit to 7 sts before marker. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Ring Finger:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Transfer next 16 sts [7 sts from back, 2 CO sts from previous rnd, and 7 sts from palm] to waste yarn, removing marker, pm, CO 2 sts over gap, knit to 7 sts before marker. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Middle Finger:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Transfer next 16 sts [7 sts from back, 2 CO sts from previous rnd, and 7 sts from palm] to waste yarn, removing marker, pm, CO 2 sts over gap–20 sts remain for Index Finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work in St st until piece is long enough to cover index finger (approximately 29 rnds)."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * around–10 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Middle, Ring, and Pinkie Fingers, and Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Working one Finger at a time, transfer sts from waste yarn to dpns. Rejoin MC; pick up and knit 2 sts from sts CO between previous Finger and current Finger (or from sts CO over gap for Thumb), knit to end–18 sts for Middle Finger [18 sts for Ring Finger; 16 sts for Pinkie; 22 sts for Thumb]. Join for working in the rnd; pm for beginning of rnd. Work in St st until piece is long enough to cover finger (approximately ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("36 rnds for Middle Finger, 32 rnds for Ring Finger, ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("25 rnds for Pinkie, and 25 rnds for Thumb). Complete as for Index Finger–9 sts remain for Middle Finger [9 sts for Ring Finger; 8 sts for Pinkie; 11 sts for Thumb].")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Right Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Glove to beginning of Thumb Shaping.  [")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note: Terms for “back of hand” and “palm” should be reversed.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K30, pm, M1L, k2, M1R, pm, knit to end–62 sts. Complete as for Left Glove, working Fingers in the same order.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Block Gloves. Fold facings under at picot rnd and neatly sew to WS, being careful not to let sts show on RS. Weave in remaining ends.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "GoldenBraceletsChart.eps",
      "src": "images/fairIsleChartKey.jpg",
      "width": "320"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "gothic"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Evening712.tiff",
      "height": "479",
      "src": "images/Evening712_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "gothic"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-22",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Gothic")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("These sequined hand warmers evoke the angular structure of Gothic architecture. The flared cuff \nis attenuated by twisted ribbing at the wrist, and the back of the hand tapers gently to a point. The last three stitches on the back of the hand are worked in I-cord, which is formed into a loop and circles the middle finger. The sequined decoration and elegant shape make them appropriate for formal occasions, but they also look great in more casual settings. Wear them also if your hands get cold while working at a computer; the shape does not impede the movement of your hands while typing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "gothic"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 8\" cuff circumference, "), _c('br'), _vm._v("6¾\" wrist circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Rowan Yarns Kid Classic (70% lambswool/ 26% kid mohair / 4% nylon; 151 yards [140 meters] / 50 grams): 1 ball #828 feather")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles "), _c('br'), _vm._v("(dpn) size US 6 (4 mm)"), _c('br'), _vm._v("One set of five double-pointed needles "), _c('br'), _vm._v("size US 7 (4.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain "), _c('br'), _vm._v("correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch marker; 20 coordinating sequins; "), _c('br'), _vm._v("sewing needle and thread")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("20 sts and 28 rnds = 4\" (10 cm) in Stockinette stitch (St st) using larger needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note"), _c('br')]), _c('span', {
    staticClass: "char-style-override-32",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('b', [_vm._v("Channel Island CO")]), _c('br')]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This is an unusual cast-on, which, in addition to being strong, also makes a very decorative edging. First, cut a piece of yarn a bit longer than the length you would normally use for the Long-Tail CO. Pull another long length from the ball to be left for the tail; do NOT cut it. Holding both strands together, make a slip knot of both strands, about 6\" from the end of the cut strand nearest to the ball, and put it on the right-hand needle, with the two long tails hanging to the front of the needle, and the end attached to the ball and the short end of the cut strand to the back. Hold the two tails in your left hand and the ball strand in your right hand (disregard the short end of the cut strand). *Wrap the double tail twice around your left thumb counterclockwise (opposite from Long-Tail CO), bring the ball strand under the needle and over the top to the back ")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("to create a yarnover, and hold it in your right hand, insert the needle into both wraps on your thumb, and with the ball strand, wrap the yarn around the needle as if to knit, draw the loop through the thumb wraps, and pull them gently to tighten. You have just cast on two stitches. Repeat from * until the required number of stitches have been cast on. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Hand Warmers (both alike)")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With larger needles and Channel Island CO, CO 39 sts.")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Divide sts among larger dpns [9-10-10-10]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Purl into each loop of slipknot at beginning of CO to increase 1 st, purl to end–40 sts.")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Begin St st. Work even for 17 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K5, k2tog, k4, k2tog, [k5, k2tog] twice, k4, k2tog, k5, k2tog–34 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Change to smaller dpns. *K1-tbl, p1; repeat from * to end. Repeat last rnd 4 times.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to larger dpns and St st. Work even for 4 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("BO 17 sts, knit to end–17 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (WS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Change to working back and forth. P1, k1, purl to last 2 sts, k1, p1."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Begin Diamond Chart. Work Rows 1-15, working decreases as indicated in Chart–3 sts remain. Do NOT turn work after last row.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "gothic"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (RS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Change to I-Cord ")])]), _c('a', {
    attrs: {
      "href": "#/section#filigree"
    }
  }, [_vm._v("(see page 138)")]), _vm._v(". Work even until I-Cord measures approximately 2½\". Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off. Using tail, sew end of I-Cord to WS at beginning of I-Cord to make a small loop, being careful not to let sts show on RS.")]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends. Block Hand Warmers. Sew sequins in the “window” created inside the twist-stitch motif on Rows 4-8 of the chart. "), _c('a', {
    attrs: {
      "href": "#/section#gothic"
    }
  }, [_vm._v("(See photo, page 72)")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "GothicChart.eps",
      "src": "images/GothicChart_fmt.jpg",
      "width": "260"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "GothicChartKeyREV.eps",
      "height": "551",
      "src": "images/GothicChartKeyREV_fmt.png",
      "width": "254"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "gretel"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Gretel18.tiff",
      "height": "479",
      "src": "images/Gretel18_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "gretel"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-22",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Gretel")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Icelandic wool is one of my favorite kinds of yarn, especially for weather-proof accessories. I love the rusticity, the colors (especially the heathers), the combination of water-repelling guard hairs and soft, warm undercoat fibers, and the history––the sheep in Iceland today are descendants of those brought there by Vikings over a thousand years ago. These mittens are knit flat, with an extra strand of a lighter-weight yarn held along with the working yarn on the palm side to create a reinforced palm. \n\t\t\t\tThe lighter-weight yarn is also used for the side gore, and for the decorative embroidery and edging.\n\t\t\t\tUse your imagination with the needle-felted motif: the single-ply yarn can be used to “draw” any \n\t\t\t\tdesign on the mittens.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "gretel"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 8¼\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Reynolds Lopi (100% Icelandic wool; 110 yards [100 meters] / 100 grams): 1 ball #9971 amber heather (MC)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Reynolds Lite-Lopi (100% Icelandic wool; 110 yards [100 meters] / 50 grams): 1 ball #1401 hazel heather (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One pair straight needles size US 10½ "), _c('br'), _vm._v("(6.5 mm)"), _c('br'), _vm._v("One pair straight needles size US 8 (5 mm)"), _c('br'), _vm._v("One set of five double-pointed needles (dpn) "), _c('br'), _vm._v("size US 10½ (6.5 mm)"), _c('br'), _vm._v("One set of five double-pointed needles size "), _c('br'), _vm._v("US 8 (5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; waste yarn in contrasting color; tapestry needle; 4\"x4\" piece of tightly woven cloth; sewing pins; six ¾\" wood buttons; sewing needle and thread; felting needle")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("12 sts and 18 rows = 4\" (10 cm) in Stockinette stitch (St st) using larger needles and MC"), _c('br'), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note"), _c('br')]), _c('span', {
    staticClass: "char-style-override-32",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('b', [_vm._v("Needle Felting")])]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("A felting needle is a thin triangular or star-shaped needle with barbs all over the tip. You can use it to apply fleece or pieces of woolen yarn with low twist (any single which you can untwist gently and see the fibers from which it was spun). When you stab the needle through the appliqué and into the base, the barbs push the fibers of the appliqué into the fibers of the base, but it pulls out cleanly so they stay there. Repeated stabbing eventually mixes the two layers so much that the appliqué stays in place. If you turn it over to the wrong side, you will be able to see the color of the appliqué coming through the base. This method can be used to “draw” onto an item with yarn."), _c('br'), _c('br'), _c('br')]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.38em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Left Mitten")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1.03em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With larger straight needles and MC, CO 26 sts. Begin St st, beginning with a WS row. Work even for 11 rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Palm Reinforcement")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 1 (RS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K1, place marker (pm), change to 1 strand each of MC and A held together, k11, drop A, pm, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Purl to marker, change to 1 strand each of MC and A held together, p11, drop A, p1. Work even in St st for 8 rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (RS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 8 sts, change to waste yarn and k4, slip these 4 sts back to left-hand needle, change to working yarn, knit these 4 sts again, work to end. Work even until piece measures approximately 8½\" from the beginning, ending with a WS row. Cut A.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Mitten Top"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 1 (RS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Continuing with MC only, k1, *k2, k2tog; repeat from * to last st, k1–20 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 2 and 4: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Purl.\t"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, *k1, k2tog; repeat from * to last st, k1–14 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 5: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K1, *k2tog; repeat from * to last st, k1–8 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Carefully remove waste yarn from Thumb sts and place bottom 4 sts and top 5 sts onto 2 larger dpns. Rejoin MC and A, and with 1 strand of each held together, pick up and knit 1 st at side of Thumb Opening, knit across 4 bottom sts, pick up and knit 1 st at other side of Thumb Opening, knit across 5 top sts–11 sts. Distribute sts among 3 dpns. Join for working in the rnd; pm for beginning of rnd.")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K2tog, k2, ssk, k5–9 sts remain. Work even until piece is long enough to cover thumb (approximately 9 more rnds). "), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to last st, k1–5 sts remain. Cut yarns, leaving 6\" tails. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Right Mitten")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Mitten to beginning of Palm Reinforcement."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 1 (RS):")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K14, pm, change to 1 strand each "), _c('br'), _vm._v("of MC and A held together, k11, drop A, pm, k1."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P1, change to 1 strand each of MC and A held together, p11, drop A, purl to end. Work even in St st for 8 rows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next row (RS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 14 sts, change to waste yarn and k4, slip these 4 sts back to left-hand needle, change to working yarn, knit these 4 sts again, work to end. Work even until piece measures approximately 8½\" from the beginning, ending with a WS row. Cut A. Complete as for Left Mitten.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Side Gore")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With RS facing, smaller straight needles and A, beginning at top of Mitten and working one half stitch in from edge, pick up and knit 42 sts down side edge of Mitten (edge of ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("back")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of hand for Left Mitten, edge of ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("palm")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of hand for Right Mitten).")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "gretel"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Short Row Shaping")]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 140)")]), _c('br'), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 1 (WS) and 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P11, wrp-t, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 3 and 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P11, purl next st together with wrap, p10, wrp-t, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rows 5 and 6: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("P22, purl next st together with wrap, p9, wrp-t, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 7:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P32, purl next st together with wrap, purl to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 8:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to end."), _c('br'), _vm._v("BO all sts purlwise, leaving a very long tail. Using tail, sew BO edge to other side edge of Mitten, working one half stitch in from edge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decoration")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Place cloth inside Mitten to prevent felting needle from going through all layers. Cut strand of A, lay it on center back of Mitten and twist it into shape shown in illustration. Anchor it with pins if you like, then begin punching felting needle through yarn and Mitten. Begin with a few jabs at each crossover point until shape is set as desired, then continue jabbing over whole strand until it is embedded in Mitten fabric. Cut any extra off strand, and felt in ends with needle. With A threaded on tapestry needle, make 4 French Knots "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 137)")]), _vm._v(" as shown in illustration.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I-Cord Edging")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With 2 smaller dpns and A, CO 4 sts. With WS facing, beginning and ending at outside edges of Gore, work Applied I-Cord "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 138)")]), _vm._v(" around lower edge of Mitten. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With sewing needle and thread, sew 3 buttons to side edges of each Mitten, one approximately 2½\" up from lower edge, one approximately 2\" down from top of Mitten, and one spaced in between. Sew buttons on so that Mitten edges are gathered together over Gore; do not sew through Gore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "GretelEmbroideryIllo.eps",
      "height": "346",
      "src": "images/GretelEmbroideryIllo_fmt.jpg",
      "width": "342"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "houndstoothMiscellany"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "KnittingBook57.tiff",
      "height": "479",
      "src": "images/KnittingBook57_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "houndstoothMiscellany"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-18",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Houndstooth Miscellany")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("These arm warmers feature a composition \n\t\t\t\tof three different patterns: houndstooth \n\t\t\t\tin two sizes and a herringbone pattern. The \n\t\t\t\tcolorwork pattern is reminiscent of rustic \n\t\t\t\ttweedy cloth; but worked in this wool/alpaca \n\t\t\t\tblend yarn, it has a subtle chiaroscuro \n\t\t\t\thaze from the long fibers. The arm warmers \n\t\t\t\tare worked flat, and edged with a crab \n\t\t\t\tstitch crocheted edging. The suede lacing \n\t\t\t\tinstills the design with an equestrian quality. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "houndstoothMiscellany"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 5½\" wrist circumference; "), _c('br'), _vm._v("approximately 9\" forearm circumference; "), _c('br'), _vm._v("approximately 8¼\" long, including edging"), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy-italic char-style-override-18",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note: Since Arm Warmer laces up, circumference measurements are adjustable.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Nashua Handknits Creative Focus Worsted (75% wool / 25% alpaca; 220 yards "), _c('br'), _vm._v("[201 meters] / 100 grams): 1 ball each #0410 espresso (MC) and #2120 "), _c('br'), _vm._v("brick (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One pair straight needles size US 7 (4.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Crochet hook size US 7 (4.5 mm); 3½ yards (3 meters) suede cord")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("22 sts and 22 rows = 4\" (10 cm) in Stockinette stitch (St st) over Houndstooth Chart ")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "houndstoothMiscellany"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Arm Warmers (both alike)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With MC and Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", CO 30 sts. Purl 1 row."), _c('br'), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (RS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Begin Houndstooth Chart. Work even, working increases as indicated in Chart, until Chart is completed–50 sts. Cut A. BO all sts purlwise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Block pieces to measurements. With RS facing, using crochet hook and MC, beginning at lower right-hand corner of Arm Warmer, work Crab Stitch Edging around entire piece.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-18",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Crab Stitch Edging")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 1 (Single Crochet): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work from right to left for right-handers, or from left to right for left-handers. Make slipknot and place on hook. *Insert hook into next st (along lower or upper edge) or between two rows (side edges). Yo hook, pull through to RS–2 loops on hook. Yo hook, draw through both loops–1 loop on hook. Repeat from * to end. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: It may be necessary to skip a row every so often when working along a side edge, in order to prevent puckering.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 2 (Reverse Single Crochet):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work from left to right for right-handers, or from right to left for left-handers. *Insert hook into previous single crochet, yo hook, pull through to RS–2 loops on hook. Yo hook, draw through both loops–1 loop on hook. Repeat from * to end. Fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cut 60\" (1.5 meter) length of suede cord and lace through gaps in Row 2 of Crab Stitch Edging in a criss-cross fashion, working from wrist edge to forearm edge. Knot at top of Arm Warmer and trim to desired length.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "HoundstoothMiscellanyChart.eps",
      "src": "images/houndsToothKey.jpg",
      "width": "424"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "jackInTheBox"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "FlipTop37.tiff",
      "height": "479",
      "src": "images/FlipTop37_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "jackInTheBox"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-22",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Jack-in-the-Box")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("These flip-top mittens look like regular mittens \n\t\t\t\tfrom the back but open to reveal a short \n\t\t\t\tinner cuff that frees your fingers for dexterous \n\t\t\t\ttasks. They are constructed just as regular \n\t\t\t\tmittens to the base of the fingers, then the palm stitches are placed on hold and new stitches \n\t\t\t\tare cast on to replace them. Work continues \n\t\t\t\tin the round to the top of the mitten. The held \n\t\t\t\tstitches are worked later to create the inner \n\t\t\t\tcuff. A classic staghorn cable adorns the back \n\t\t\t\tof the hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "jackInTheBox"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Children’s (Women’s Medium, Women’s Large, Men’s)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 6¾ (7½, 8¼, 9)\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Brown Sheep Company Lamb’s Pride Worsted (85% wool / 15% mohair; "), _c('br'), _vm._v("190 yards [173 meters] / 113 grams): 1 (1, 2, 2) skeins #M22 autumn harvest (#M113 oregano, #M113 oregano, #M06 deep charcoal)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 6 (4 mm)"), _c('br'), _vm._v("One set of five double-pointed needles size US 7 (4.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; cable needle (cn); "), _c('br'), _vm._v("waste yarn in contrasting color; two ½\" (13 mm) buttons")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("20 sts and 28 rnds = 4\" (10 cm) in Stockinette stitch (St st) using larger needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("16 sts = 2¼\" (5.5 cm) over Staghorn Cable using larger needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stitch Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff Pattern")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("(multiple of 4 sts; 6-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Set-up Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K3, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2, k1 wrapping yarn around needle twice, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2, slip 1 st purlwise wyib dropping extra wrap, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *T3R, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K1 wrapping yarn around needle twice, k2, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 5:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *Slip 1 st purlwise wyib dropping extra wrap, k2, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 6:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *C3L, p1; repeat from * around."), _c('br'), _vm._v("Repeat Rnds 1-6 for Cuff Pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("1x1 Rib")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("(multiple of 2 sts; 1-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Rnds: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, p1; repeat from * around.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Abbreviations")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("T3R (Twist 3 Right): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit into front of third st on left-hand needle, knit into front of first st on left-hand needle, dropping it off the needle, then knit into front of next st on left-hand needle, dropping it and the previously-knit third st off at the same time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("C3L (Cross 3 Left):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Slip next st to cn and hold to front, k2, k1 from cn.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Mitten")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "jackInTheBox"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(" and smaller needles, CO 32 (36, 40, 44) sts, divide among 4 needles [8-8-8-8 (8-8-8-12, 8-12-8-12, 8-12-12-12)]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. Begin Cuff Pattern. Work Set-up Rnd once, work Rnds 1-6 two (three, three, three) times, then work Rnds 1-3 one (zero, zero, one) time.")]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hand")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to larger needles. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Children’s Size Only"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, M1L, [k3, M1L] twice, k2, M1L, [k3, M1L] twice, knit to end–38 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Adult Sizes Only")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-28",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1 (2, 1), [M1L, k3 (3, 4)] 5 times, M1, knit to end–42 (46, 50) sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Sizes")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Redistribute sts among 4 needles [11-11-8-8 (12-12-9-9, 13-13-10-10, 14-14-11-11)].")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K1 (2, 3, 4), p2, pm, work Staghorn Cable Chart over next 16 sts, pm, p2, knit to end of rnd. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Needles 1 and 2 hold the sts for the back of the hand, and Needles 3 and 4 hold the sts for the palm and Thumb.] ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work even for 2 rnds."), _c('br'), _c('br')]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work 22 (24, 26, 28) sts, pm for Thumb, M1L, k2, M1R, pm, knit to end–40 (44, 48, 52) sts. Work even for 2 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work to first Thumb marker, slip marker (sm), M1L, knit to second Thumb marker, M1R, sm, knit to end–42 (46, 50, 54) sts. Work even for 2 rnds. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Repeat last 3 rnds 1 (3, 3, 4) times, then repeat Increase Rnd 2 once–46 (54, 58, 64) sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work to first Thumb marker, transfer next 10 (14, 14, 16) sts to waste yarn for Thumb, removing Thumb markers, CO 2 sts over gap, knit to end–38 (42, 46, 50) sts remain. Work even for "), _c('br'), _vm._v("3 (4, 4, 6) rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Create Flip-Top")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 22 (24, 26, 28) sts, transfer next 16 (18, 20, 22) sts to waste yarn for Inner Palm Cuff, CO 16 (18, 20, 22) sts using Backward Loop CO "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", work to end.")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note: It is easiest to CO all new sts to one dpn, then divide them between Needles 3 and 4 on the following rnd.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 1 and 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Continuing in the rnd, work 22 (24, 26, 28) sts, change to 1x1 Rib and work to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Children’s Size and Women’s Size Large Only")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3 (Buttonhole Rnd):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work 28 (34) sts, ssk, yo, work to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Women’s Size Medium and Men’s Size Only")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3 (Buttonhole Rnd):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work 33 (39) sts, yo, k2tog, work to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Sizes")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 4 and 5: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Repeat Rnd 1."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 6: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 22 (24, 26, 28) sts, change to St st and work to end. Work even until piece is long enough to cover fingertips [approximately 5¼ (7, 7½, 8½)\" from end of Cuff].")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Top")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Children’s Size Only")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P2tog, [k2tog] 8 times, p2tog, *k2tog; repeat from * around–19 sts remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Adult Sizes Only")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [K2tog] 1 (1, 2) times, p2tog, [k2tog] 8 times, p2tog, *k2tog; repeat from * around–21 (23, 25) sts remain")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Sizes")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * to last st, k1–10 (11, 12, 13) sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work Inner Palm Cuff")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO and larger dpn, CO 16 (18, 20, 22) sts, divide sts between 2 needles [8-8 (9-9, 10-10, 11-11)]. Transfer Inner Palm Cuff sts from waste yarn to 2 additional larger dpns. With RS facing, knit across Inner Palm Cuff sts. Join for working in the rnd; pm for beginning of rnd. Begin 1x1 Rib. Work even for 5 rnds. BO all sts in pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer Thumb sts from waste yarn to larger dpn. Rejoin yarn; pick up and knit 2 sts from sts CO over gap–12 (16, 16, 18) sts. Join for working in the rnd; pm for beginning of rnd. Work even in St st until piece is long enough to cover thumb [approximately 11 (14, 14, 16) rnds].")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * around–6 (8, 8, 9) sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "FlipTop25.tiff",
      "height": "240",
      "src": "images/FlipTop25_fmt.jpg",
      "width": "199"
    }
  }), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Left Mitten")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Right Mitten to beginning of Thumb Shaping. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work 36 (40, 44, 48) sts, pm for Thumb, M1L, k2, M1R–40 (44, 48, 52) sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work to Thumb marker, sm, M1L, knit to end, M1R–42 (46, 50, 54) sts. Work even for 2 rnds."), _c('br'), _vm._v("Repeat last 3 rnds 1 (3, 3, 4) times, then repeat Increase Rnd 2 once–46 (54, 58, 64) sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work to Thumb marker, transfer "), _c('br'), _vm._v("next 10 (14, 14, 16) sts to waste yarn for Thumb, removing Thumb marker, CO 2 sts over gap–38 (42, 46, 50) sts remain. Work even for 3 (4, 4, 6) rnds.  Complete as for Right Mitten.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Turn Mitten WS out. Arrange Inner Palm Cuff so that it is encircling the Mitten at the same height all around and is not twisted. Sew the lower edge of the Inner Cuff to the back of the Mitten, being careful not to let sts show on RS. Turn Mitten RS out and check fit of Inner Cuff before fastening off sewing strand. Adjust if necessary. Sew button to Inner Cuff to correspond to buttonhole. Repeat for second Mitten. Weave in ends.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "JackintheBoxChart.eps",
      "src": "images/stagHornCableChart.jpg",
      "width": "300"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "negativeSpace"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "NegativeSpace6.tiff",
      "height": "479",
      "src": "images/NegativeSpace6_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "negativeSpace"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Negative Space")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("The interesting construction of this fingerless mitten is rooted in the shape of a Norwegian-style mitten called a ")]), _c('span', {
    staticClass: "Introduction-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("brudevott")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(", or ")]), _c('span', {
    staticClass: "Introduction-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("kirkevott, ")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("worn at weddings or to church")]), _c('span', {
    staticClass: "Introduction-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(". ")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("They are alternatively known as")]), _c('span', {
    staticClass: "Introduction-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" halvvanter med tunge, ")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("or half-gloves with a tongue. Having ")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("the palm side open and the back of the hand covered")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" has its advantages: The hand is partially shielded from the elements, yet you can still use your fingers to dig into ")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("pockets for keys, take a photo, or even knit outside ")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("in the cold. Stitches are provisionally cast on, the mitten is worked to the tip, then the provisional cast-on is undone and an I-cord bind-off is worked, which continues into an I-cord coil forming the cuff. The cutaway section of the mitten is also edged in I-cord, giving it a substantial shape.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "negativeSpace"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7½\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Reynolds Lopi (100% Icelandic wool; "), _c('br'), _vm._v("110 yards [100 meters] / 100 grams): "), _c('br'), _vm._v("2 balls #9966 cypress green heather")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 10 (6 mm)"), _c('br'), _vm._v("One set of five double-pointed needles size US 10½ (6.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Crochet hook size J/10 (6 mm); "), _c('br'), _vm._v("stitch marker; safety pin; waste yarn in contrasting color")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("14 sts and 19 rnds = 4\" (10 cm) in Stockinette stitch (St st) using smaller needles")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _c('br'), _vm._v("Left Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With crochet hook and waste yarn, work crochet chain 30 sts long. Fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With one smaller dpn and working yarn, pick up and knit 26 sts from the “bumps” of the chain. Divide sts among 4 smaller needles [7-6-7-6]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. Knit 3 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Place a safety pin in the thirteenth st.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K12, M1R, k1 (marked st), M1L, knit to end–28 sts. Knit 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to marked st, M1R, k1, M1L, knit to end–30 sts."), _c('br'), _vm._v("Repeat last 3 rnds twice–34 sts. Knit 1 rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K12, transfer next 9 sts to waste yarn for Thumb, CO 1 st over gap, knit to end–26 sts remain."), _c('br'), _vm._v("Knit 4 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Cutout"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, BO 9 sts, k15–17 sts remain. Knit first 2 sts of the rnd again; place all sts on one dpn."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (WS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Change to working back and forth. Purl."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Row:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, ssk, knit to last 4 sts, k2tog, k2–15 sts remain. Purl 1 row. "), _c('br'), _vm._v("Rep Decrease Row every other row 4 times–7 sts remain. Purl 1 row."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (RS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, dcd, k2–5 sts remain. Purl 1 row."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, dcd, k1–3 sts remain. BO remaining sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer the 9 sts from waste yarn to 3 smaller dpns. Rejoin yarn; pick up and knit 1 st from st CO over gap–10 sts. Join for working in the rnd; pm for beginning of rnd. Knit 4 rnds. BO all sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Glove"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Glove to beginning of Thumb Shaping.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("P")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("lace a safety pin in the first st.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" M1R, k1 (marked st), M1L, knit to end–28 sts. Knit 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to marked st, M1R, k1, M1L, knit to end–30 sts."), _c('br'), _vm._v("Repeat last 3 rnds twice–34 sts. Knit 1 rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 9 sts to waste yarn for Thumb, CO 1 st over gap, knit to end–26 sts remain. Complete as for Left Glove.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "negativeSpace"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Undo crochet chain by pulling out end of chain that was fastened off and unzipping chain, exposing live sts. Transfer sts to 3 larger dpns [8-8-10]. CO 3 sts on fourth dpn and, beginning at side of hand and using fourth and fifth dpns, work I-Cord BO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 138)")]), _vm._v(" until there are 3 sts left on working dpn. Change to Applied I-Cord "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 138)")]), _vm._v(", working into I-Cord BO just completed to form a coiled Cuff, as follows: pick up and knit 1 st out of the middle of the second st of the I-Cord BO (1½ sts will be showing on the RS), slide sts back to other end of dpn, k2, k2tog-tbl. Continue in this fashion, picking up 1 st from Applied I-Cord when you have worked around I-Cord BO, until you have gone round the entire Cuff 3 more times (you should have 4 coils), working to just past where I-Cord BO began. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off. Sew end neatly to coil below. "), _c('br'), _vm._v("Repeat for other Glove.")]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cutout Edging"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With larger dpns and beginning at BO top of Cutout, work 3-st Applied I-Cord around Cutout edge, ending at BO sts. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off. Sew end neatly to beginning of I-Cord.")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends.")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p'), _vm._v(" "), _c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "NegativeSpace31.tiff",
      "height": "230",
      "src": "images/NegativeSpace31_fmt.jpg",
      "width": "198"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "plush"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Plush16.tiff",
      "height": "479",
      "src": "images/Plush16_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "plush"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-7",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Plush")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("The soft, loop-knit cuffs of these mittens cushion \n\t\t\t\tthe wrists in comfort while the wovenlike stitch \n\t\t\t\tpattern on the hand shuffles around the colors \n\t\t\t\tof the variegated yarn for a uniform effect \n\t\t\t\t(rather than the pooling and stacking effect that\n\t\t\t\toften occurs when this type of yarn is worked\n\t\t\t\tin many other stitch patterns). Sizes are included for both children and women. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Child’s (Women’s Medium, "), _c('br'), _vm._v("Women’s Large)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 6½ (7½, 8)\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Manos del Uruguay Wool (100% wool; 138 yards [126 meters ] / 100 grams): "), _c('br'), _vm._v("1 (2, 2) hanks #118")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 9 (5.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch marker; waste yarn in contrasting color")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-7",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("16 sts and 26 rnds = 4\" (10 cm) in "), _c('br'), _vm._v("Half-Linen Stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stitch Pattern"), _c('br')]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Half-Linen Stitch"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("(multiple of 2 sts; 4-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K1, slip 1 purlwise wyif; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 2 and 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*Slip 1 purlwise wyif, k1; repeat from * around."), _c('br'), _vm._v("Repeat Rnds 1-4 for Half-Linen Stitch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Abbreviations")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("ML (Make Loop): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit into next st, but do not drop from needle, bring yarn forward between needle tips, wrap once around left thumb, bring yarn to back between needle tips, knit into back of same st, dropping it from left-hand needle, but leaving loop on thumb, insert tip of left-hand needle into fronts of last 2 sts on right-hand needle, k2tog-tbl, drop loop from thumb."), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Mittens (both alike)")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("CO 20 (24, 26) sts, divide among 4 needles [5-5-5-5 (6-6-6-6, 6-7-6-7)]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *ML; repeat from * around."), _c('br'), _vm._v("Repeat Rnds 1 and 2 three (four, four) times, then repeat Rnd 1 once.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hand")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit, increase 6 sts evenly spaced around–26 (30, 32) sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to Half-Linen Stitch. Work even until piece measures approximately 2 (2½, 2¾)\" from Increase Rnd, ending with Rnd 1 or 3 of Half-Linen Stitch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K14 (16, 17), change to waste yarn and k5 (6, 6), slip these 5 (6, 6) sts back to left-hand needle, change to working yarn, knit these 5 (6, 6) sts again, work to end. Work even until Mitten measures approximately 5¼ (6¾, 7¼)\" from Increase Rnd, or until piece is long enough to cover fingertips.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Mitten Top"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to end–13 (15, 16) sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * to last 1 (1, 0) st, k1 (1, 0)–7 (8, 8) sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    staticClass: "char-style-override-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Carefully remove waste yarn from Thumb sts and place bottom 5 (6, 6) sts and top 6 (7, 7) sts onto 2 dpns. Rejoin working yarn, pick up and knit 2 sts at side of Thumb Opening, knit across 5 (6, 6) bottom sts, pick up and knit 2 sts at other side of Thumb Opening, knit across 4 (5, 5) top sts, k2tog–14 (16, 16) sts. Distribute sts among 3 needles. Join for working in the rnd; pm for beginning of rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Slip 1, k2tog, k3 (4, 4), ssk, k2tog, k3 (4, 4), ssk (last st of rnd and first st of next rnd)–10 (12, 12) sts remain. Begin Half-Linen Stitch, aligning with palm stitches. Work even until piece is long enough to cover Thumb."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * around–5 (6, 6) sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Plush649.tiff",
      "height": "230",
      "src": "images/Plush649_fmt.jpg",
      "width": "198"
    }
  })])])]), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "plush"
    }
  }, [_c('br')]), _c('a', {
    attrs: {
      "id": "poppy"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Poppy695.tiff",
      "height": "479",
      "src": "images/Poppy695_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "poppy"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Poppy")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("The mohair ruffles of these gloves are \n\t\t\t\tknit first in rows, then worked with the cuff \n\t\t\t\tstitches later. I think the ruffles resemble \n\t\t\t\tthe delicate petals of a poppy after they have emerged from the bud. Block the ruffles \n\t\t\t\twhen you have finished knitting to prevent\n\t\t\t\tthem from curling up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "poppy"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Women’s Small (Medium, Large)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7¼ (7½, 8)\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Naturally Alpine DK/8-ply (100% pure "), _c('br'), _vm._v("New Zealand wool; 437 yards [400 meters] / "), _c('br'), _vm._v("200 grams): 1 hank #1002 pale green (MC)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Naturally Mist 1-ply (80% superfine kid mohair / "), _c('br'), _vm._v("20% nylon; 181 yards [166 meters] / 25 grams): "), _c('br'), _vm._v("1 ball #605 chartreuse (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One pair straight needles size US 4 (3.5 mm)"), _c('br'), _vm._v("One set of five double-pointed needles (dpn) "), _c('br'), _vm._v("size US 4 (3.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; waste yarn in contrasting color; tapestry needle")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("23 sts and 29 rnds = 4\" (10 cm) in Stockinette stitch (St st) using MC")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "poppy"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ruffles (make 10)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With straight needles, Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", and A, CO 60 (63, 66) sts, leaving a long tail. Begin St st; work even for 3 rows, beginning with a purl row. "), _c('br'), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Row: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, k2tog; repeat from * to end–40 (42, 44) sts remain. Cut yarn; transfer sts to waste yarn.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Left Glove")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With dpns, Long-Tail CO, and MC, CO 40 (42, 44) sts, divide among 4 dpns [10-10-10-10 (11-10-11-10, 11-11-11-11)]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. Knit 1 rnd. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles 1 and 2 hold the sts for the palm, and Needles")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" 3 and 4 hold the sts for the back of the hand.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd (Join Ruffle):")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Holding Ruffle at RS of Glove, with RS of Ruffle facing out, *slip first st of Ruffle to left-hand needle, k2tog (first st on left-hand needle with first st of Ruffle); repeat from * to end. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Leave Ruffle sts on waste yarn until rnd is complete, then remove waste yarn.] ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work even in St st for 3 rnds. Repeat last 4 rnds 4 times.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hand")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K20 (21, 22), M1R; repeat from * to end–42 (44, 46) sts. Work even until piece measures approximately 2½ (2¾, 2¾)\" from last increase rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K12 (13, 14), change to waste yarn and k8, slip these 8 sts back to left-hand needle, change to working yarn, knit these 8 sts again, work to end. Work even until piece reaches base of fingers [approximately 10 (11, 12) more rnds].")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Divide for Fingers"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer all sts from Needle 2 to Needle 1 for palm of hand, and all sts from Needle 4 to Needle 3 for back of hand–21 (22, 23) sts on each needle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Use a piece of waste yarn threaded on a tapestry needle to hold the sts for each Finger.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer first 5 sts from Needle 1 and last 5 sts from Needle 3 to waste yarn–10 sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ring Finger: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 4 (5, 5) sts from each of Needles 1 and 3 to waste yarn–8 (10, 10) sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Middle Finger:")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 5 (5, 6) sts from each of Needles 1 and 3 to waste yarn–10 (10, 12) sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger:")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer remaining 7 sts from each of Needles 1 and 3 to waste yarn–14 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns. K5 (palm sts), CO 2 sts over gap between Pinkie and Ring Finger, k5 (back of hand sts)–12 sts. Join for working in the rnd; pm for beginning of rnd. Work in St st until piece is long enough to cover Pinkie (approximately 17 rnds).")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * to end–6 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ring Finger and Middle Finger"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Working one Finger at a time, transfer sts from waste yarn to dpns. Rejoin MC; pick up and knit 2 sts from sts CO between previous Finger and current Finger, k4 (5, 5) for Ring Finger [k5 (5, 6) for Middle Finger], CO 2 sts over gap between current Finger and next Finger, k4 (5, 5) for Ring Finger [k5 (5, 6) for Middle Finger]–12 (14, 14) sts for Ring Finger [14 (14, 16) sts for Middle Finger]. Join for working in the rnd; pm for beginning of rnd. Work in St st until piece is long enough to cover finger (approximately 22 rnds for Ring Finger; 24 rnds for Middle Finger). Complete as for Pinkie–6 (7, 7) sts remain for Ring Finger [7, (7, 8) sts for Middle Finger].")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns. Rejoin MC; pick up and knit 2 sts from sts CO between Middle Finger and Index Finger, k14–16 sts. Join for working in the rnd; pm for beginning of rnd. Work in St st until piece is long enough to cover Index Finger (approximately 22 rnds). Complete as for Pinkie–8 sts remain. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Carefully remove waste yarn from Thumb sts and place bottom 8 sts and top 9 sts onto 2 dpns, being careful not to twist sts. Rejoin MC; pick up and knit 2 sts at side of Thumb Opening, knit across 8 bottom sts, pick up and knit 2 sts at other side of Thumb Opening, knit across 9 top sts–21 sts. Distribute sts evenly among 3 dpns. Join for working in the rnd; pm for beginning of rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, k2tog, k6, ssk, k2tog, k7, ssk (last st of rnd together with first st of next rnd)–17 sts remain. Work even in St st until piece is long enough to cover Thumb (approximately 21 rnds).")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to last st, k1–9 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Glove to Thumb Opening. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Terms for “back of hand” and “palm” should be reversed.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K22 (23, 24), change to waste yarn and k8, slip these 8 sts back to left-hand needle, change to working yarn, knit these 8 sts again, work to end. Complete as for Left Glove, working Fingers in the same order.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sew side edges of Ruffles together, using CO tails. Block Gloves, pinning Ruffles down and steaming with iron and damp cloth in order to make them lie flat. Weave in ends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Poppy686.tiff",
      "height": "231",
      "src": "images/Poppy686_fmt.jpg",
      "width": "198"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "rusalka"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "RuSalka369.tiff",
      "height": "479",
      "src": "images/RuSalka369_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "rusalka"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-24",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Rusalka")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("These fingerless gloves are worked in a yarn \n\t\t\t\tmade of silk and SeaCell, a new fiber derived\n\t\t\t\tfrom seaweed. Sea minerals are absorbed \n\t\t\t\tby the skin as you knit and wear this yarn—what \n\t\t\t\tan unusual way to get your vitamins! The beads \n\t\t\t\tare sewn on with gold thread after knitting; \n\t\t\t\tthe purled pattern in the cuff serves as an easy \n\t\t\t\tguide for adding the beads. I chose gold \n\t\t\t\tthread for beading because, wherever it shows, \n\t\t\t\tit shines like sunlight on the sea. Rusalka is\n\t\t\t\tthe name of a Slavic water-dwelling fairy creature.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "rusalka"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Women’s Small/Medium (Large)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 6¾ (7¼)\" circumference. "), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-copy-italic char-style-override-24",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note: Silk will stretch when worn.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Hand Maiden Sea Silk (70% silk / "), _c('br'), _vm._v("30% SeaCell; 437 yards [400 meters] / "), _c('br'), _vm._v("100 grams): 1 hank Nova Scotia")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 2½ (3 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch marker; removable markers; 6 mm bugle beads in coordinating color; beading needle with eye small enough to pass through beads; 8 yards gold metallic thread")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("28 sts and 36 rows = 4\" (10 cm) in Stockinette stitch (St st)")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "rusalka"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Left Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", CO 48 sts, divide evenly among 4 needles. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. "), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Needles 1 and 2 hold the sts for the palm and Thumb, and Needles 3 and 4 hold the sts for the back of the hand.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Begin St st. Work even for 2 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Begin Cuff Chart. Work even for 18 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to St st. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Eyelet Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2, yo, k2tog; repeat from * to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Size Large Only"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K24, M1L; repeat from * to end–50 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Both Sizes")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work even for 8 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K23 (24), pm, M1R, k2, M1L, pm, knit to end–50 (52) sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to first marker, slip marker (sm), M1R, knit to next marker, M1L, sm, knit to end–52 (54) sts."), _c('br'), _vm._v("Repeat last 3 rnds 5 times–62 (64) sts. Work even for 1 rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K23 (24), transfer next 16 sts to waste yarn for Thumb, CO 2 sts over gap, knit to end–48 (50) sts remain. Work even until piece is long enough to reach base of fingers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Finger Spaces")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("BO 24 (25) sts, placing removable markers between BO sts as follows: First marker 5 sts from beg of rnd, second marker 6 sts after first marker, third marker 6 (7) sts after second marker (7 sts remain to end of BO). BO next 7 sts, *[yo, pass last knit st over yo and off right-hand needle] 4 (5) times, insert right-hand needle into space where third marker is, pick up and knit 1 st, then pass next-to-last st over picked-up st and off right-hand needle. Working back along short yo chain, pick up 1 st in each loop of chain, then pass next-to-last st over picked-up st and off right-hand needle, until you reach left-hand needle again.* BO next 6 (7) sts, then repeat from * to *. BO next 6 sts, then repeat from * to *. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: You are creating small bridges to the other side of the Glove.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" BO remaining 5 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns. Rejoin yarn; pick up and knit 2 sts from sts CO over gap–18 sts. Knit 4 rnds. BO all sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Glove, working Finger Spaces in the same order. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Terms for “back of hand” and “palm” should be reversed.] ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Block Gloves lightly. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-24",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Twisted Cords (make 2)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cut 3 strands of yarn approximately 60\" long. With all 3 strands held together, tie one end to a stationary object. Twist strands until Cord begins to double up on itself tightly. Distribute twist evenly, tie ends together with overhand knot and trim. Tie overhand knot in folded end and trim. Thread Cord through eyelet rnd and tie at side of hand. Trim again if desired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-24",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Beads"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With gold thread threaded on a beading needle, sew bugle beads to patterned section of cuff, using the purl sts as a guideline, and sewing beads alongside purl sts (see photo), as follows: Knot thread and secure on WS, at the point where you wish to begin. Bring needle through to RS, thread bead onto needle, pull needle and thread through bead, pass needle to WS at very end of bead. *Bring needle through to RS at beg of last bead, insert needle through bead again, and thread another bead onto needle, pull needle and thread through bead, pass needle to WS at very end of bead. Repeat from * until bead motif is complete. For more information, see "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("page 135")]), _vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "image "
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "RuSalka369.tiff",
      "height": "479",
      "src": "images/toughGloves.jpg",
      "width": "396"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "RuSalka394.tiff",
      "src": "images/cuffChart.jpg",
      "width": "300"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "sheltie"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Sheltie91.tiff",
      "height": "479",
      "src": "images/Sheltie91_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "sheltie"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-25",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Sheltie")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("The soft mohair underlayer blooms through the openwork overlay of these dual-layered mittens. Air is trapped between the layers and warmed by your hands, providing insulation. The overlay is worked in an old Shetland pattern called Bird’s Eye (collected by Barbara G. Walker in ")]), _c('span', {
    staticClass: "Introduction-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("A Treasury of Knitting Patterns")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("). The name “Sheltie” ")]), _vm._v(" "), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("is an Anglicization of the Gaelic ")]), _c('span', {
    staticClass: "Introduction-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("sealtaí")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(", meaning Shetland pony. Shetland ponies grow dual ")]), _vm._v(" "), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("coats for the winter that insulate them against the wind and weather as they forage for seaweed ")]), _vm._v(" "), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("along the shore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "sheltie"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 8\" Underlayer circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Garnstudio Vienna (90% mohair / 10% polyester; 104 yards [95 meters] / 50 grams): 1 ball #21 winter white (MC)"), _c('br'), _vm._v("Garnstudio Alaska (100% wool; 82 yards [75 meters] / 50 grams): 2 balls #50 brown heather (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) "), _c('br'), _vm._v("size US 9 (5.5 mm)"), _c('br'), _vm._v("One pair straight needles size US 9 (5.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch marker; removable st marker; waste yarn in contrasting color")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("13 sts and 19 rnds = 4\" (10 cm) in Stockinette stitch (St st) using MC")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("14 sts and 20 rows = 4\" (10 cm) in Bird’s Eye Pattern using A")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Note"), _c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This Mitten consists of two parts: a mohair Underlayer and a wool Overlay in an openwork pattern, which allows the mohair to be seen. The Underlayer is worked in the round. The Overlay is worked flat, then sewn up. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stitch Pattern")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Bird’s Eye Pattern")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-25",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("(multiple of 4 sts; 4-row repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 1 (WS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog, [yo] twice, k2tog; repeat from * to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, [k1, p1] into double yo, k1; repeat from * to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, *k2tog, [yo] twice, k2tog; repeat from * to last 2 sts, k2."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Row 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, *k1, [k1, p1] into double yo, k1; repeat from * to last 2 sts, k2."), _c('br'), _vm._v("Repeat Rows 1-4 for Bird’s Eye Pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Underlayer (both mittens alike)")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "sheltie"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With MC, Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", and dpns, CO 26 sts, divide among 4 needles [7-6-7-6]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. Begin St st; work even for 25 rnds (piece should measure approximately 5¼\" from the beginning).")]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K14, change to waste yarn and k5, slip these 5 sts back to left-hand needle, change to MC, knit these 5 sts again, work to end. Work even until piece is long enough to cover fingers (approximately 20 rows; piece should measure approximately 9¾\" from the beginning).")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to end–13 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to last st, k1–7 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    staticClass: "char-style-override-25",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Carefully remove waste yarn from Thumb sts and place bottom 5 sts and top 6 sts onto 2 dpns. Rejoin MC; pick up and knit 1 st at side of Thumb Opening, knit across 5 bottom sts, pick up and knit 1 st at other side of Thumb Opening, knit across 6 top sts–13 sts. Distribute sts among 3 dpns. Join for working in the rnd; pm for beginning of rnd. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2tog, k3, ssk, k6–11 sts remain. Work even until piece is long enough to cover thumb (approximately 12 rnds)."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * to last st, k1–6 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Overlay")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Right Overlay"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With straight needles, Long-Tail CO and A, CO 28 sts. Begin Bird’s Eye Pattern. Work even for 18 rows (piece should measure approximately 3¾\" from the beginning). Place a marker on the RS of the work. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (WS): ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K2, k2tog, [yo] twice, k2tog, k2, transfer next 5 sts to waste yarn for Thumb, CO 5 sts over gap using Backward Loop CO "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", k1, *k2tog, [yo] twice, k2tog; repeat from * to last 2 sts, k2."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Continue in pattern, knitting the 5 CO sts. Work even, working pattern over entire row, until piece measures approximately 8½\" from the beginning, ending with a RS row."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Row (WS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to end–14 sts remain. Repeat Decrease Row once–7 sts remain. Cut yarn, leaving a very long tail. Draw through remaining sts, pull tight and fasten off. Using tail, sew side seam, making sure RS is on the outside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    staticClass: "char-style-override-25",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Thumb is worked flat, but it will be easier to work with 2 dpns, rather than straight needles.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With RS of Overlay facing, and with CO edge facing away from you (Mitten is upside-down), carefully remove waste yarn from Thumb sts, and transfer sts to dpn, being careful not to twist sts, then using Long-Tail CO and A, CO 7 sts at end of row (your left)–12 sts. Cut yarn and slide sts to opposite end of dpn. Do NOT turn work. Rejoin A, ready to work a WS row. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (WS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Begin Bird’s Eye Pattern, beginning with Row 3. Work even for 14 rows."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Row:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to end–6 sts remain. Cut yarn, leaving a 12\" tail. Draw through remaining sts, pull tight and fasten off. Using tail, sew Thumb seam. Sew bottom of Thumb neatly to sts CO over Thumb Opening.")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _c('br'), _vm._v("Left Overlay")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-25",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Right Overlay to beginning of Thumb Opening. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row (WS):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, [k2tog, [yo] twice, k2tog] 3 times, k1, transfer next 5 sts to waste yarn for Thumb, CO 5 sts over gap using Backward Loop CO, k2, k2tog, [yo] twice, k2tog, k2."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Row:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Continue in pattern, knitting the 5 CO sts. Work as for Right Overlay to beginning of Thumb.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With RS of Overlay facing, and with CO edge facing toward you (Mitten is right-side-up), carefully remove waste yarn from Thumb sts and transfer sts to dpn, being careful not to twist sts. Using Long-Tail CO and A, CO 7 sts at end of row (your left)–12 sts. Do NOT cut yarn. Turn work, ready to work a WS row across CO sts first, then held sts. Complete as for Right Overlay. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    staticClass: "char-style-override-25",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Place Underlayers inside Overlays. Allow CO edge of Underlayer to roll up to CO edge of Overlay, and sew in place. If desired, using A, sew both pieces together on the WS at the tip of the hand and the Thumb.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "snug"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Snug31.tiff",
      "height": "479",
      "src": "images/Snug31_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "snug"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-22",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Snug")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("I first encountered ultra-warm thrummed mittens, worked with a combination of yarn and short pieces of roving (called thrums), a few years ago in a gift shop in Toronto. The mittens in the shop were made in Newfoundland, where the winters are harsh and snowy. I spent the first eighteen years of my life in a similar climate (in Cape Breton) but, oddly enough, had never seen a pair of these mittens. To add to the insulating qualities of my thrummed mittens, I designed a snug wind- and snow-proof cuff by folding a length of ribbing to the inside and stitching it down after knitting. The outside of the cuff features rings of reverse Stockinette stitch, which lend an air of sculptural grace. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "snug"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Size")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Child’s (Woman’s)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7 (8)\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Fleece Artist Blue Face Leicester Aran (100% wool; 410 yards [375 meters] / 250 grams): 1 hank bronze (MC)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Fleece Artist Blue Face Leicester Sliver Roving (100% wool; 50 grams): 1 braid lichen (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 7 (4.5 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; waste yarn in contrasting color")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("18 sts and 24 rnds = 4\" (10 cm) in Stockinette stitch (St st)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Note")]), _c('span', {
    staticClass: "char-style-override-22"
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The thrums are created by taking short pieces of roving and knitting them in as you work. ")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("They appear as big puffy stitches on the outside,")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" and fleecy ends on the inside. To prepare roving for making thrums, divide the roving into strips 2 to 3 times the width of MC yarn, then pull off 4\" lengths to knit as thrums. When you want to place a thrum, twist it a bit at the middle section, then fold it in half. Insert the right-hand needle into the next st, loop the folded thrum over the needle as you would to wrap a st when knitting and draw the thrum through the st and off the left-hand needle. Run the working yarn behind the stitch, ready to knit the following st. Make Thumb thrums a bit smaller so there will be room for your thumb.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Left Mitten")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "snug"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ribbed Inner Cuff")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", CO 28 (32) sts, divide among 4 needles [7-7-7-7 (8-8-8-8)]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd."), _c('br'), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, p1; repeat from * to end. Work even for 11 (14) rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Cuff"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Purl 4 (5) rnds. *Knit 3 (4) rnds. Purl 3 (4) rnds. "), _c('br'), _vm._v("Repeat from * once.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hand")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K1, M1R, k12 (14), M1L, k1; repeat from * to end–32 (36) sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 3 and 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 5 (Thrum Rnd):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K3, thrum 1; repeat from * to end.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 6:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K15 (17), pm for Thumb, M1L, knit to end–33 (37) sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 7: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit to Thumb marker, slip marker (sm), "), _c('br'), _vm._v("M1L, knit to end–34 (38) sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 8:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 9 and 10:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Repeat Rnd 7–36 (40) sts after Rnd 10."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 11 (Thrum Rnd):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K1, *thrum 1, k3; repeat from * to last 3 sts, thrum 1, k2."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 12 and 13:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Repeat Rnd 7–38 (42) sts after Rnd 13.")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 14:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 15 and 16:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Repeat Rnd 7–40 (44) sts after Rnd 16.")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 17:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Repeat Rnd 5.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Child’s Size Only")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 18:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Woman’s Size Only")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 18 and 19: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Repeat Rnd 7–46 sts after Rnd 19."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 20:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Both Sizes")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 19 (21):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K15 (17), transfer next 10 (12) "), _c('br'), _vm._v("sts to waste yarn for Thumb, CO 2 sts over gap, knit to end–32 (36) sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 20 (22):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Child’s Size Only")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 21 and 22:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Both Sizes")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 23:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Repeat Rnd 11."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 24-28:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 29:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Repeat Rnd 5."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 30-34:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 35:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Repeat Rnd 11.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Woman’s Size Only")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 36-40:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 41:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Repeat Rnd 5.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Mitten Top"), _c('br')]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Both Sizes")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 36 (42) and alternate rnds: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 37 (43):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2, k2tog; repeat from * to end–24 (27) sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 39 (45):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K1, k2tog; repeat from * to end–16 (18) sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 41 (47):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to end–8 (9) sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns. Rejoin yarn; pick up and knit 2 sts from sts CO over gap–12 (14) sts. Join for working in the rnd; pm for beginning of rnd. Knit 4 (2) rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thrum Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work thrums so that they are staggered in relation to last Thrum Rnd worked on Thumb.")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [Note: For Woman’s Size, since the number of sts is not divisible by 4, you must leave only 2 sts between thrums twice, instead of 3. Do this on inside of Thumb to be less noticeable.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Continuing in St st, work even for 5 rnds. Repeat Thrum")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd, staggering sts in relation to last Thrum Rnd worked. ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work even until piece is long enough to cover Thumb. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K2tog; repeat from * to end–6 (7) sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Right Mitten")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Mitten to beginning of Thumb Shaping.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 6:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K17 (19), M1R, pm for Thumb, knit to end–33 (37) sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 7: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit to Thumb marker, M1R, sm, knit to end–34 (38) sts. Complete as for Left Mitten.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Turn Mitten inside out. Fold Ribbed Inner Cuff to WS and slipstitch neatly to base of hand, being careful not to let sts show on RS. Weave in ends.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Snug42.tiff",
      "height": "234",
      "src": "images/Snug42_fmt.jpg",
      "width": "198"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "standardDeviation"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "KnittingBook34.tiff",
      "height": "479",
      "src": "images/KnittingBook34_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "standardDeviation"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-18",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Standard Deviation")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("While watching the 1980 film ")]), _c('span', {
    staticClass: "Introduction-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("The Shining")]), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(", one of the images I found striking was the ominous repetition of patterns in the carpeting of the Overlook Hotel. I love the colors and the highly stylized motifs and how variations in color and patterning occur from room to room but are united by a recurring theme. These fingerless gloves are worked in the round in a fine Norwegian wool, from the top edge down, with stitches cast on for the thumb gore and then decreased to the wrist. The main pattern is repeated at the wrist in a ")]), _vm._v(" "), _c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("deviation from the original color sequence, and the thumb gore features a motif from the main pattern, worked in the negative of the original color sequence. This project is named for a term used in statistical mathematics to describe how far the individual elements vary from the mean.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "standardDeviation"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7¼\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Rauma Finullgarn (100% wool; 180 yards [165 meters] / 50 grams): 1 ball each #410 dark brown (MC), #499 burgundy (A), #439 fuchsia (B), #445 bright salmon (C), and #4197 gold (D)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 2½ (3 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; tapestry needle")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("30 sts and 30 rows = 4\" (10 cm) in Stockinette stitch (St st) over Hand Chart ")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Note")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-18",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gloves are worked in the round from upper edge to lower edge, with extra sts cast on for the Thumb Gore, which are then decreased to wrist.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('br')])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "standardDeviation"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Fingerless Gloves (both alike)")]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(" and MC, CO 54 sts, divide among 4 needles [14-13-14-13]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd.")]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Begin Chart"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work Hand Chart across 54 sts, carrying colors not in use loosely up the WS at beginning of Chart. Work even until entire Rnd 16 is complete."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 17:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work 26 sts, BO 2 sts, work to end–52 sts remain. ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 18: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work to BO sts, pm, with MC and Backward Loop CO "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", CO 19 sts for Thumb Gore (dividing CO sts between Needles 2 and 3), pm, work to end–71 sts. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Carry the contrasting color tightly behind the BO sts; the strand will be worked into the Thumb Gore finishing.]"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 19: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work to marker, work across Thumb Gore Chart, work to end. Work even, working decreases as shown in Thumb Gore Chart, until Thumb Gore Chart is complete, removing Thumb Gore markers on last rnd–54 sts remain."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 38-44: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work even until Hand Chart is complete. With MC, BO all sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-18",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Block Gloves. With MC threaded on tapestry needle, work Closed Blanket Stitch "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(" along sts BO and CO for Thumb Gore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "StandardDeviationChartsKey.eps",
      "src": "images/thumbGoreChart.jpg",
      "width": "420"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "strata"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Layering561.tiff",
      "height": "479",
      "src": "images/Layering561_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "strata"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-22",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Strata")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("I enjoy layering gloves for both warmth and \n\t\t\t\taesthetic purposes, so for this project I created three different layers—Traditional Gloves (with fingers),  Short-Fingered Gloves, and Fingerless Gloves—each of which can be worn alone or in combination with one or both of the other layers. The Traditional \t\t\t\tGloves and Short-Fingered Gloves are worked in \n\t\t\t\ta sport-weight alpaca and silk blend yarn that is \n\t\t\t\tfine enough for layering without unnecessary bulk; the Fingerless Gloves are worked in a brushed \n\t\t\t\talpaca that is lofty, not heavy. I hope you’ll make several pairs in your favorite colors and mix \n\t\t\t\tand match with abandon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "strata"
    }
  }, [_c('p'), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Traditional Gloves and Short-Fingered Gloves: Women’s Medium (Large, X-Large)"), _c('br'), _vm._v("Fingerless Gloves: Women’s Medium (Large)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Traditional Gloves and Short-Fingered Gloves: Approximately 7½ (8, 8½)\" circumference. Fingerless Gloves: Approximately 7½ (8)\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Blue Sky Alpacas Alpaca Silk (50% alpaca / 50% silk; 146 yards [133 meters] / "), _c('br'), _vm._v("50 grams): Traditional Gloves: 2 hanks #126 brick, or #137 sapphire (MC); "), _c('br'), _vm._v("Short-Fingered Gloves: 1 (2, 2) hanks #100 slate (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Blue Sky Alpacas Brushed Suri (67% baby suri / 22% merino / 11% bamboo; 142 yards [130 meters] / 50 grams): Fingerless Gloves: 1 hank #900 whipped cream (B)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 3 (3.25 mm)"), _c('br'), _vm._v("One set of five double-pointed needles size US 6 (4 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; waste yarn in contrasting color; tapestry needle")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-22",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("26 sts and 34 rnds = 4\" (10 cm) in Stockinette stitch (St st) using smaller needles and MC or A")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("20 sts and 28 rnds = 4\" (10 cm) in Stockinette stitch using larger needles and B")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "strata"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note")]), _c('span', {
    staticClass: "char-style-override-22",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-33",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When making the Short-Fingered Gloves, make them one size larger than you made the Gloves if you plan to layer them over the Gloves. Make them your regular size if you plan to wear them mainly by themselves or underneath the Fingerless Gloves. Note that the pattern for the Traditional Gloves and Short-Fingered Gloves includes Medium (Large, X-Large) sizing. The Fingerless Gloves have more give and will fit over the other layers, and should therefore be made in your regular size. "), _c('br'), _c('br'), _vm._v("Use the Backward Loop CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(" to add sts over the Thumb gap and between Fingers. ")]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stitch Pattern"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("1x1 Rib "), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("(multiple of 2 sts; 1-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All Rnds:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K1, p1; repeat from * around."), _c('br')]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Traditional Gloves and Short-Fingered Gloves")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Left Glove/Short-Fingered Glove"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO "), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", smaller dpn and MC or A, CO 48 (52, 56) sts, divide evenly among 4 needles [12-12-12-12 (13-13-13-13, 14-14-14-14)]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Needles 1 and 2 hold the sts for the palm and Thumb, and Needles 3 and 4 hold the sts for the back of the hand.] ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Begin St st. Work even for 9 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K10 (11, 12), k2tog; repeat from * around–44 (48, 52) sts remain. Work even for 9 rnds.")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Decrease Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K9 (10, 11), k2tog; repeat from * around–40 (44, 48) sts remain. Work even for 9 rnds.")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K10 (11, 12), M1L; repeat from * around–44 (48, 52) sts remain. Work even for 2 rnds.")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Increase Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K5 (6, 6), *M1L, k11 (12, 13); repeat from * to last 6 (6, 7) sts, M1L, knit to end–48 (52, 56) sts. Work even for 2 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 3: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K22 (24, 26), pm for Thumb, M1L, k2, M1R, pm, knit to end–50 (54, 58) sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to first marker, slip marker (sm), M1L, knit to second marker, M1R, sm, knit to end–52 (56, 60) sts. Work even for 2 rnds. "), _c('br'), _vm._v("Repeat last 3 rnds 4 times, then repeat Increase Rnd 4 once–62 (66, 70) sts. Work even for 1 rnd."), _c('br'), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to first marker, transfer next 16 sts to waste yarn for Thumb, removing Thumb markers, CO 2 sts over gap, knit to end–48 (52, 56) sts remain. Work even until piece is long enough to reach base of Pinkie [approximately 8 (9, 10) rnds], ending 6 (6, 7) sts before end of rnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Divide for Fingers")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Use a piece of waste yarn threaded on a tapestry needle to hold the sts for each finger.]")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 12 (12, 14) sts [last 6 (6, 7) sts of rnd and first 6 (6, 7) of next rnd] to waste yarn, pm, CO 2 sts over gap, knit to 5 (6, 6) sts before marker.")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ring Finger:")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 12 (14, 14) sts [5 (6, 6) sts from back, 2 CO sts from previous rnd, and 5 (6, 6) sts from palm] to waste yarn, removing marker, pm, CO 2 sts over gap, knit to 6 (6, 7) sts before marker. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Middle Finger:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Transfer next 14 (14, 16) sts [(6 (6, 7) sts from "), _c('br'), _vm._v("back, 2 CO sts from previous rnd, and 6 (6, 7) sts from palm] to waste yarn, removing marker, pm, CO 2 sts over gap–16 (18, 18) sts remain for "), _c('br'), _vm._v("Index Finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger")]), _c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Short-fingered Gloves:")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work in St st for 8 rnds. BO all sts. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gloves: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work in St st until piece is long enough to cover index finger (approximately 24 rnds).")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Decrease Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * around–8 (9, 9) sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off, with tail to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Middle, Ring and Pinkie Fingers, and Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Working one Finger at a time, transfer sts from waste yarn to dpns. Rejoin MC or A; pick up and knit 2 sts from CO between previous Finger and current Finger (or from sts CO over gap for Thumb)–16 (16, 18) sts for Middle Finger [14 (16, 16) sts for Ring Finger; 14 (14, 16) sts for Pinkie; 18 sts for Thumb]. Join for working in the rnd; pm for beginning of rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Short Fingered Gloves:")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work in St st for 8 rnds (Middle Finger, Thumb) or 7 rnds (Ring Finger, Pinkie). BO all sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gloves: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work in St st until piece is long enough to cover finger (approximately 26 rnds for Middle Finger, 25 rnds for Ring Finger, 21 rnds for Pinkie, and 21 rnds for Thumb). Complete as for Index Finger–8 (8, 9) sts remain for Middle Finger [7 (8, 8) sts for Ring Finger; 7 (7, 8) sts for Pinkie; 9 sts for Thumb].")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Right Glove/Short-Fingered Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Left Glove/Short-Fingered Glove to beginning of Thumb Shaping. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Terms for")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("“back of hand” and “palm” should be reversed, and Thumb sts will be on Needle 3.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K24 (26, 28), pm, M1L, k2, M1R, pm, knit to end–50 (54, 58) sts. Work "), _c('br'), _vm._v("even for 2 rnds. Complete as for Left Glove/Short-Fingered Glove, working fingers in same order.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends, using yarn tails from rejoined "), _c('br'), _vm._v("yarn to close any gaps around the bases of "), _c('br'), _vm._v("the Fingers and Thumb. Block Gloves/Short-Fingered Gloves.")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads-",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Fingerless Gloves (both alike)")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO, larger dpn and B, CO 36 (38) sts, divide among 4 needles [9-9-9-9 (10-9-10-9)]. Join for working in the rnd, being careful not to twist sts; pm for beginning of rnd. Begin 1x1 Rib. Work even for 3 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to St st. Work even for 3 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K16 (17), k2tog; repeat from * around–34 (36) sts remain. Work even for 4 rnds.")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Decrease Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K15 (16), k2tog; repeat from * around–32 (34) sts remain. Work even for 7 rnds.")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Increase Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K16 (17), M1L; repeat from * around–34 (36) sts. Work even for 4 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 2: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K8 (9), M1L, k9, M1L; repeat from * around–38 (40) sts. Work even for 2 rnds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Shape Thumb")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K18 (19), pm, M1L, k2, M1R, pm, knit to end–40 (42) sts. Work even for 2 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd 4: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Knit to first marker, sm, M1L, knit to second marker, M1R, sm, knit to end–42 (44) sts. Work even for 2 rnds."), _c('br'), _vm._v("Repeat last 3 rnds 3 times, then repeat Increase Rnd 4 once–50 (52) sts. Work even for 1 rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit to first marker, transfer next 14 sts to waste yarn, removing Thumb markers, CO 2 sts over gap, knit to end–38 (40) sts remain. Work even in St st until piece is long enough to cover knuckles [approximately 11 (12) rnds]."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Change to 1x1 Rib. Work even for 3 rnds. BO all sts in Rib.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-22",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer 14 sts from waste yarn to dpns. Rejoin yarn; pick up and knit 2 sts from sts CO over gap–16 sts. Join for working in the rnd; pm for beginning of rnd. Begin 1x1 Rib. Work even for 3 rnds. BO all sts in Rib.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-22",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends. Block Fingerless Gloves.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Layering8.tiff",
      "height": "479",
      "src": "images/Layering8_fmt.jpg",
      "width": "396"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "tapisserie"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Tapisserie_060.tif",
      "height": "479",
      "src": "images/Tapisserie_060_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "tapisserie"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Tapisserie")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Worked in the round and edged with Latvian \n\t\t\t\tbraid, these arm warmers combine motifs inspired \n\t\t\t\tby medieval tapestries with a long-established \n\t\t\t\tdetail of folk-knitting. The result is a sophisticated accessory that can be worn as a casual adornment or for utilitarian warmth. Before central heating,\n\t\t\t\ttapestries kept drafts out of cold, stone-walled rooms, and also displayed the wealth of the owner, as they were expensive to commission. With these, you can keep the draft out of your sleeves while\n\t\t\t\tdisplaying your knitting prowess.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "tapisserie"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7¾\" wrist circumference; approximately 10\" forearm circumference; "), _c('br'), _vm._v("approximately 7¼\" long")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Reynolds Whiskey (100% wool; 195 yards [177 meters] / 50 grams): 1 ball each #16 burgundy heather (MC) and #103 chartreuse heather (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) size US 3 (3.25 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("28 sts and 30 rnds = 4\" (10 cm) in Stockinette stitch (St st) over Fair Isle Chart")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-34",
    attrs: {
      "xml:lang": "en-GB"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stitch Pattern"), _c('br')]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2 char-style-override-16",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Latvian Braid"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("(multiple of 2 sts + 1; 3-rnd repeat)"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" *K1 with MC, k1 with A; repeat from * to last st, k1 with MC."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 2:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" With both yarns at front of work, p1 with MC, *bring A over MC and p1, bring MC over A and p1; repeat from * around. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Note: Yarns will be twisted after this rnd, but will be untwisted on Rnd 3.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" With both yarns at front of work, p1 with MC, *bring A under MC and p1, bring MC under A and p1; repeat from * around.")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "tapisserie"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-16",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Arm Warmers (both alike)")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(" and MC, CO 54 sts, divide among 4 needles [14-13-14-13]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd."), _c('br'), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K7, pm, purl to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[K1 with MC, k1 with A] 3 times, k1 with MC, slip marker (sm), change to Latvian Braid and work to end. Repeat last rnd once."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[K1 with A, k1 with MC] 3 times, k1 with A, sm, work to end in Latvian Braid."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 7 sts as established, sm, change to MC and knit to end, carrying A behind MC.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Begin Chart"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 16 sts of Chart, pm, work to last 9 sts of Chart, pm, work to end. Work even for 3 rnds."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd (Rnd 5 of Chart):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work to second marker, sm, work to next marker working increases as indicated, sm, work to end–56 sts. Work even until Chart is complete, continuing to work increases between second and third markers, as indicated in Chart–70 sts."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work 7 sts as established, change to Latvian Braid and work to end. Repeat last rnd twice. Cut A."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("With MC, knit."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("BO 7 sts knitwise, BO to end purlwise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finishing")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Weave in ends. Block Arm Warmers to measurements. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "TapisserieChart.eps",
      "src": "images/fairIsleChartKey2.jpg",
      "width": "440"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "welig"
    }
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Welig261.tiff",
      "height": "479",
      "src": "images/Welig261_fmt.jpg",
      "width": "396"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "welig"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-24",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Welig")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("The namesake of this pattern is the Old English name for willow, a water-loving tree known to occasionally break through concrete with its roots in search of water. The cables of this glove twist and climb all the way up the fingers, becoming entangled with each other on the way, perhaps seeking water (or snow). Bobbles represent knotted bark. Some of the cables on these gloves actually travel through one another, likening them to the branches of a tree that grow so close that one begins to grow around the other.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "welig"
    }
  }, [_c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sizes")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One size (to fit average woman)")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Finished Measurements"), _c('br')]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Approximately 7½\" circumference")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yarn")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Nashua Handknits Julia (50% wool / 25% mohair/ 25% alpaca; 93 yards [84 meters] / 50 grams): 2 skeins #4936 blue thyme")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Needles")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("One set of five double-pointed needles (dpn) "), _c('br'), _vm._v("size US 6 (4 mm)"), _c('br'), _vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Notions")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("Stitch markers; 2 cable needles (cn); waste yarn in contrasting color; tapestry needle")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-Subhead char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Gauge")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("21 sts and 29 rnds = 4\" (10 cm) in Stockinette stitch (St st) "), _c('br'), _vm._v("26 sts = 3¾\" (9.5 cm) over Cable Chart, after Rnd 23")])]), _vm._v(" "), _c('p', {
    staticClass: "Tool-List",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("Note")]), _c('span', {
    staticClass: "char-style-override-24"
  }, [_c('br')]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("You will have to rearrange the sts between Needles 1 and 2 occasionally in order to complete certain cables and bobbles. Reposition them once you have finished the necessary maneuver.")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Abbreviations"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("RT (Right Twist):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit into front of second st, then knit into front of first st, slip both sts from left-hand needle together.")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br'), _vm._v("LT (Left Twist):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Knit into back of second st, then knit into front of first st, slip both sts from left-hand needle together.")]), _c('span', {
    staticClass: "char-style-override-24"
  }, [_c('br')])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "welig"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-24 pt10",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Right Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Using Long-Tail CO ")])]), _c('a', {
    attrs: {
      "href": "#/section#specialTechniques"
    }
  }, [_vm._v("(see page 136)")]), _vm._v(", CO 42 sts, divide among 4 needles [12-12-9-9]. Join for working in the rnd, being careful not to twist sts; place marker (pm) for beginning of rnd. "), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Needles 1 and 2 hold the sts for the back of the hand, and Needles 3 and 4 hold the sts for the palm.]")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work Cable Chart across 24 sts, pm, *k2, p2; repeat from * to last 2 sts, k2. Work even until Rnd 23 of Chart has been completed."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Increase Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Working increases as indicated in Chart, work across Chart to first marker, sm, k1, M1R, knit to last st, M1L, k1–46 sts. Work even, working from Chart to first marker, and in St st to end, until Rnd 39 of Chart has been completed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work to first marker, k1, change to waste yarn and k7, slip these 7 sts back to left-hand needle, change to working yarn, knit these 7 sts again, work to end. Work even until Rnd 50 of Chart has been completed."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd (Rnd 51):")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P2tog, k1, LT, p1, p2tog, k3, [p2tog] twice, k3, p1, p2tog, k1, LT, p2, knit to end, removing markers–41 sts remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Divide for Fingers"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer all sts from Needle 2 to Needle 1 for back of hand, and all sts from Needle 4 to Needle 3 for palm. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("[Note: Use a piece of waste yarn threaded on a tapestry needle to hold the sts for each finger.]")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer first 5 sts from Needle 1 and last 5 sts from Needle 3 to waste yarn–10 sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ring Finger: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 5 sts from Needle 1 and next 4 sts from Needle 3 to waste yarn–9 sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Middle Finger:")]), _c('span', {
    staticClass: "x-C-Project-Body-Subhead-2",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer next 5 sts from each of Needles 1 and 3 to waste yarn–10 sts. ")]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer remaining 6 sts from each of Needles 1 and 3 to waste yarn–12 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie")]), _c('span', {
    staticClass: "char-style-override-24",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Set-Up Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("P1, k3, p1, CO 2 sts over gap between Pinkie and Ring Finger, k5–12 sts. Join for working in the rnd; pm for beginning of rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P1, RT, k1, p1, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 2 and 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P1, k3, p1, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P1, k1, LT, p1, knit to end."), _c('br'), _vm._v("Repeat Rnds 1-4 until piece is long enough to cover Pinkie (approximately 16 rnds)."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("*K2tog; repeat from * around–6 sts remain. Cut yarn, leaving a 6\" tail. Draw through remaining sts, pull tight and fasten off to the inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ring Finger and Middle Finger"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Working one Finger at a time, transfer sts from waste yarn to dpns. Rejoin yarn; pick up and knit 2 sts from sts CO for previous Finger, p1, k3, p1, CO 2 sts over gap between current Finger and next Finger, knit to end­­–13 sts for Ring Finger; 14 sts for Middle Finger. Join for working in the rnd; pm for beginning of rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, p1, k3, p1, knit to end. Repeat Rnd 1 until piece is long enough to cover finger "), _c('br'), _vm._v("(approximately 20 rnds for Ring Finger; 22 rnds for Middle Finger)."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [K2tog] 6 times (7 times for Middle Finger), k1 (0 for Middle Finger)–7 sts remain. Complete as for Pinkie.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns. Rejoin yarn; pick up and knit 2 sts from sts CO for Middle Finger, p1, k3, p2, k6–14 sts. Join for working in the rnd; pm for beginning of rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, p1, RT, k1, p2, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 2 and 4:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, p1, k3, p2, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, p1, k1, LT, p2, knit to end."), _c('br'), _vm._v("Repeat Rnds 1-4 until piece is long enough to cover Index Finger (approximately 21 rnds). "), _c('br'), _vm._v("Complete as for Pinkie–7 sts remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Carefully remove waste yarn from Thumb sts and place bottom 7 sts and top 8 sts onto dpns, being careful not to twist sts. Rejoin yarn to bottom sts, pick up and knit 2 sts at side of Thumb Opening, knit across 7 bottom sts, pick up and knit 2 sts at other side of Thumb Opening, knit across 8 top sts–19 sts. Redistribute sts among 3 dpns. Join for working in the rnd; pm for beginning of rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K1, k2tog, k5, ssk, k2tog, k6, ssk (last st of rnd together with first st of next rnd)–15 sts remain. Work even in St st until piece is long enough to cover Thumb (approximately 20 rnds). "), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" [K2tog] 7 times, k1–8 sts remain. Complete as for Pinkie.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Left Glove")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Right Glove to Thumb Opening.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thumb Opening")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Next Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Work to first marker, k12, change to waste yarn and k7, slip these 7 sts back to left-hand needle, change to working yarn, knit these 7 sts again, k1. Work even until Rnd 50 of Chart has been completed."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Decrease Rnd (Rnd 51)")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(": P2, k1, LT, p2tog, p1, k3, [p2tog] twice, k3, p2tog, p1, k1, LT, p2tog, knit to end, removing markers–41 sts remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Divide for Fingers")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts for fingers to waste yarn as for Right Glove, reversing the order in which the fingers lie (begin with the Index Finger and end with the Pinkie).")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Index Finger ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Set-up Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P2, k3, p1, CO 2 sts over gap between Index Finger and Middle Finger, k6–14 sts. Join for working in the rnd; pm for beginning of rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" P2, RT, k1, p1, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 2 and 4: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("P2, k3, p1, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("P2, k1, LT, p1, knit to end."), _c('br'), _vm._v("Complete as for Right Index Finger."), _c('br'), _c('br')]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Middle Finger and Ring Finger"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Work as for Right Glove, reversing order.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-24",
    staticStyle: {
      "font-size": "0.94em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Pinkie")]), _c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Transfer sts from waste yarn to dpns."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Set-up Rnd:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Pick up and knit 2 sts from sts CO for Ring Finger, p1, k3, p1, k5–12 sts. Join for working in the rnd; pm for beginning of rnd."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 1:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, p1, RT, k1, p1, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnds 2 and 4: ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("K2, p1, k3, p1, knit to end."), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy-Bold--RND",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rnd 3:")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" K2, p1, k1, LT, p1, knit to end."), _c('br'), _vm._v("Complete as for Right Pinkie.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Complete as for Right Glove.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "WeligChart.eps",
      "src": "images/weightChart_01.jpg",
      "width": "420"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Graphics-Frame"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Welig257.tiff",
      "height": "702",
      "src": "images/Welig257_fmt.jpg",
      "width": "513"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "selectingMaterials"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-6",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-36"
  }, [_vm._v("Selecting Materials")])])])]), _c('a', {
    attrs: {
      "id": "selectingMaterials"
    }
  }), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "selectingMaterials"
    }
  }, [_c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Yarn"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("I like to knit with yarns made from natural fibers because they are so beautiful and feel the best in my hands. When choosing the yarns for the mittens and gloves in this book, I kept in mind the amount and type of wear they were likely to sustain. If you are planning to substitute yarns, I suggest you consider the same. I think Icelandic wool, Shetland wool, and mohair are all excellent choices for winter mittens and gloves that will be worn a lot because they are warm and strong and don’t pill a lot. I also like alpaca, which is silky and four times warmer than wool, for luxurious items. There are many patterns in this book that are intended for multi-seasonal and indoor wear; for these, I suggest cottons, soft wools, fine silk, and cashmere blends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Needles"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Most of the patterns in this book are knit in the round on double-pointed needles. I prefer sets of five over sets of four, as the mittens and the hand ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("part of gloves can be divided on four needles such that the stitches for front and back are each ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("on two needles. This makes it easier for working")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" shaping, and for generally visualizing the finished ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("product. A set of five needles also has the advantage")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" that if you lose or break one, you will be able to manage with the remaining four. Any pattern can certainly be knit with a set of four needles if you prefer. Many people enjoy knitting in the round using the magic loop technique and one long circular needle; see the bibliography for information on the book that popularized this technique.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("For mittens and gloves, it is best to use double-pointed needles that are five to seven inches long. Sometimes they are available longer, but it is cumbersome to use them for small items because the ends of the needles get in the way and the yarn gets tangled around them. If you make a lot of gloves, consider investing in some glove needles, which are quite short (about four inches long) and easier to manipulate than longer needles when working the fingers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Whenever straight needles are called for, I always use a circular needle and work back and forth on it. If you knit a lot or for long hours at a time, or if you suffer from arthritis, doing this will greatly reduce the stress on your wrists and elbows.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("When choosing needles, I like to select the metric (millimeter) size rather than the US size. The size in millimeters is an actual measurement, and I find that it is more reliable than the US sizes, which sometimes vary slightly among manufacturers. For example, a US size 6 needle is sometimes 4 mm and sometimes 4.25 mm. A needle gauge is a good tool to have on hand for double-checking.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Notions"), _c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Notions are an easy way to customize a plain item. You can sew beads onto the back of a glove, add ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("leather ties, switch leather for ribbon, or embroider")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" with sequins. If you tire of these adornments, they are usually easily changed or snipped off. For ideas, look through fashion magazines, watch people on the street, and notice how clothing designers use notions in ways you have not seen before. I also encourage you to look around in sewing, ribbon, bead, and button shops and to purchase items that appeal to you even if you don’t have a specific use in mind. As you live with them you will surely be inspired.")])])]), _c('div', {
    staticClass: "Basic-Text-Frame breakBefore"
  }, [_c('a', {
    attrs: {
      "id": "selectingMaterials"
    }
  }), _c('a', {
    attrs: {
      "id": "specialTechniques"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-6",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-36"
  }, [_vm._v("Special Techniques")])])])]), _c('a', {
    attrs: {
      "id": "specialTechniques"
    }
  }, [_c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Beading")])])]), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "specialTechniques"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("When you wish to knit with beads, begin by threading the beads onto the yarn as follows: Thread the yarn through a wire beading needle, then thread the beads onto the yarn using the beading needle. Push the beads down the yarn so there is enough yarn with which to cast on and begin knitting. In the Evening Light pattern ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/section#eveningLight"
    }
  }, [_vm._v("(see page 55)")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(", the beads are placed from the wrong side so that they fall to the right side. Working in Garter stitch on the wrong side, slide a bead up close to the needle and knit the next stitch. Note that the bead is actually sitting between two stitches on the horizontal strand. In the Box Pleats pattern "), _c('a', {
    attrs: {
      "href": "#/section#boxPleats"
    }
  }, [_vm._v("(see page 29)")]), _vm._v(", the beads are placed from the right side of the work in two ways: 1) they are placed between two purl stitches on the horizontal strand (just like how they are placed when working in Garter stitch) by purling the first stitch, pushing the bead up close to the needle and purling the next stitch; and 2), they are placed on a yarn float sitting in front of a slipped stitch, by slipping the next stitch purlwise with the yarn in front, pushing the bead up close to the needle, then working the next stitch as directed. Use a pair of needle-nose pliers to crush off any small or misshapen beads that you may have inadvertently strung. Be careful not to inadvertently cut the yarn when crushing the beads. Crush them into your hand and dispose of them safely.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Blocking")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Although mittens and gloves generally do not need to be blocked to a specific shape or set of measurements, it is a good idea to block them to even out any irregularities in your stitches. This is especially important if you will be picking up stitches, or working duplicate stitch or embroidery. It also finishes the fabric nicely, giving your work a professional look.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("I usually block mittens and gloves with a steam ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("iron and damp cloth. Place the item on the ironing ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("board. Pin out anything that you want to take on a specific shape (ruffles, etc). Place the damp cloth (a white cotton tea towel dampened with cold water is a perfect press-cloth) on top of the item. Take the iron, preheated to the wool setting, and run it lightly over the cloth while pressing the steam burst button. Don’t press the iron down hard or linger over one spot. If you are blocking cables—which you would not want to flatten—hold the iron above the cloth while you steam it. If the item is made of a fragile material, like silk or viscose, use a double thickness of damp cloth, hold the iron above the cloth, and fire short bursts of steam. It does not take a lot of heat and moisture to set fabrics such as these. Never place the iron directly on the knitting. If the press-cloth begins to dry, wet it again. If your stitches are very uneven or if you are blocking lace, you are likely to get better results by immersing the item in a basin of lukewarm water, then rolling it in a towel to squeeze out the excess moisture, and pinning it out to dry flat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Casting On")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Backward Loop CO")]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-7",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("This is the easiest and least obtrusive way to cast on stitches over a thumb hole, especially if you will be picking up from them later. *Wind the yarn around your thumb clockwise, insert right-hand needle into the front of the loop on the thumb, remove the thumb and tighten the stitch on the needle; repeat from * for remaining sts to be CO, or for casting on at the end of a row in progress. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Long-Tail CO (German Method)")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("This is the method I use most often. It is elastic, attractive, versatile and easy to work. Leaving a tail with about 1\" of yarn for each st to be cast-on, make a slipknot in the yarn and place it on the right-hand needle, with the tail to the front and the ball end to the back. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    }
  }, [_vm._v("Note: I usually leave the tail extra-long and use the excess to sew with")]), _c('span', {
    staticClass: "Project-Body-Copy char-style-override-19",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(". ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Insert the thumb and forefinger of your left hand between the strands of yarn so that the working end is around your forefinger, and the tail end is around your thumb ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("slingshot")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("”")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" fashion; *insert the tip of the right-hand needle into the front loop on the thumb, hook the strand of yarn coming from the forefinger from back to front, and draw it through the loop on your thumb; remove your thumb from the loop and pull on the working yarn to tighten the new stitch on the right-hand needle; return your thumb and forefinger to their original positions, and repeat from * for the remaining stitches to be CO. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Embroidery")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Closed Blanket Stitch")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("This stitch is worked around an edge (as shown in the illustration below). Thread the tapestry needle with no more than an arm’s length of yarn. Hold the end of the yarn parallel to the edge of the knitting. Bring the needle through from the right side to the wrong side about ¼\" from the top edge, bringing it in front of the yarn at the top edge so that it forms a “corner.” *Bring needle tip from the right side to the wrong side again, ¼\" from the edge, holding the needle tip in front of the yarn at the top edge. Repeat from *, making stitches very close together, and pulling yarn tightly. Note that this is the same as Blanket Stitch, except that the stitches are closer together. ")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Closed%20Blanket%20Stitch%20Illo.eps",
      "height": "140",
      "src": "images/ClosedBlanketStitchI_fmt.png",
      "width": "132"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("French Knots")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Thread the tapestry needle with no more than an arm’s length of yarn. Bring the needle up from the wrong side at the spot where you wish to make ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("the knot. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    }
  }, [_vm._v("Note: You may bring the needle up through")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    }
  }, [_vm._v(" the middle of a strand of yarn, rather than next to one, as this will help your knot sit on the surface. ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("With the needle lying next to where the yarn comes out, wrap the embroidery yarn 2 or 3 times tightly around the needle tip (as shown in the illustration below). Hold the wrapped yarn in place with your finger as you bring the needle to the wrong side again about ")]), _c('span', {
    staticClass: "char-style-override-35"
  }, [_vm._v("1")]), _c('span', [_vm._v("/")]), _c('span', {
    staticClass: "char-style-override-35"
  }, [_vm._v("8")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("\" from where it came up last, pulling the rest of the working yarn through the knot. The knot sits on the surface.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "French%20Knot%20Illo.eps",
      "height": "126",
      "src": "images/FrenchKnotIllo_fmt.png",
      "width": "134"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Duplicate Stitch")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Thread the tapestry needle with no more than an arm’s length of yarn. Bring the needle up from the wrong side at the base of a stitch (the pointed end of the “v”). *Thread the yarn under both ends of the stitch above the one you wish to duplicate, following the line that the yarn of the existing stitch takes. Bring the needle back to the wrong side at the base of the stitch again, then to the right side at the base of the next stitch to be duplicated. Repeat from *. You can work from left to right or right to left. Since in most cases you will not be seeing the wrong side of the work, you can bring the needle up again short distances from the last stitch duplicated if you need to work into another row. Note that you have covered the original stitches with the new color.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I-Cord")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Standard I-Cord")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Using a double-pointed needle, cast on the required number of stitches (3 or 4); the working yarn will be at the left-hand side of the needle. *Transfer the needle with the stitches to your left hand, bring the yarn around behind the work to the right-hand side; using a second double-pointed needle, knit the stitches from right to left, pulling the yarn from left to right for the first stitch; do not turn. Slide the stitches to the opposite end of the needle; repeat from * until the I-cord is the length desired. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    }
  }, [_vm._v("Note: After a few rows, the tubular shape will become apparent")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(". Cut the yarn, leaving a 6\" tail. Draw through the remaining stitches, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("Applied I-Cord")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Using a double-pointed needle, cast on the required number of stitches (3 or 4); the working yarn will be at the left-hand side of the needle. *With the wrong side of the edge to which you will apply the I-cord facing you, pick up and knit 1 st. Working as for I-cord, slide the stitches to the opposite end of the needle, pulling the yarn from left to right for the first stitch, knit to the last 2 sts, k2tog-tbl. Repeat from * to the end of the edge to which the I-cord is to be applied. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    }
  }, [_vm._v("Note: If the I-cord is worked with the WS facing, the end result on the RS is smoother and neater than if the stitches were picked with the RS facing. Notice that the decrease will appear on the WS of the work. ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Cut the yarn, leaving a 6\" tail. Draw through the remaining stitches, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-B-Project-Copy-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_vm._v("I-Cord BO")]), _c('span', {
    staticClass: "x-B-Project-Copy-Subheads-",
    staticStyle: {
      "font-size": "0.94em"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Using a double-pointed needle, cast on the required number of stitches; the working yarn will be at the left-hand side of the needle. *With the wrong side of the edge to be bound off facing you, slip the first stitch to be bound off knitwise onto the left-hand end of the I-cord needle. Working as for I-cord, slide the stitches to the opposite end of the needle, pulling the yarn from left to right for the first stitch, knit to the last 2 sts, k2tog-tbl. Repeat from * until all stitches are bound off. ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic",
    staticStyle: {
      "font-size": "1.06em"
    }
  }, [_vm._v("Note: If the I-cord is worked with the WS facing, the end result on the RS is smoother and neater than if the stitches were picked with the RS facing. Notice that the decrease will appear on the WS of the work. ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Cut the yarn, leaving a 6\" tail. Draw through the remaining stitches, pull tight and fasten off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Kitchener Stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Using a tapestry needle, thread length of yarn ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("approximately 4 times the length of section to ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("be joined. Hold pieces to be joined with WS")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("’")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("s ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("together, with needles holding sts parallel, both ends pointing in same direction. Working from right to left, insert tapestry needle into first st on front needle as if to purl, pull yarn through, leaving st on needle; insert tapestry needle into ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("first st on back needle as if to knit, pull yarn through,")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" leaving st on needle; *insert tapestry needle into first st on front needle as if to knit, pull yarn through, removing st from needle; insert tapestry needle into next st on front needle as if to purl, pull yarn through, leaving st on needle; insert tapestry needle into first st on back needle as if to purl, pull yarn through, removing st from needle; insert tapestry needle into next st on back needle as if to knit, pull yarn through, leaving st on needle. Repeat from *, working 3 or 4 sts at a time, then go back and adjust tension to match pieces being joined. When 1 st remains on each needle, cut yarn and pass through last 2 sts to fasten off. Weave tail in on WS. Note that you are sewing through two sts at a time, back and forth between front and back needles, and that every st will be worked into twice (once through each side of st).")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Reading Charts")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy"
  }, [_vm._v("Unless otherwise specified in the instructions, when working straight, charts are read from right to left for RS rows, and from left to right for WS rows. Row numbers are written at the beginning of each row. Numbers on the right indicate RS rows; numbers on the left indicate WS rows. When working circular, all rounds are read from right to left.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Short Row Shaping")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("Short row shaping is used to shape the knitting by working some, but not all, of the stitches on a given row. This creates a wedge shape of varying width and depth, depending on the number of stitches worked and the number of short rows worked. Work the number of stitches specified in the pattern, then wrap and turn (wrp-t) as follows: bring the yarn to the front, slip the next stitch purlwise, bring the yarn to the back, slip the same stitch back to the left-hand needle, and turn the work. Work back to the end of the row (or as indicated in the pattern). Wrapping the stitch prevents a hole from forming where you turned the work. Where it specifies in the directions to knit or purl a wrapped stitch together with its wrap, do exactly that. Lift the wrap up onto the needle (this makes it easier to work) and knit or purl it together with the next stitch. This hides the wrap so that it isn’t visible on the right side. You do not need to hide the wrap in Garter stitch, because the nature of the pattern hides it for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "x-A-Project-Main-Subheads- char-style-override-7",
    staticStyle: {
      "font-size": "1.33em"
    },
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stranded (Fair Isle) Colorwork Method ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("This method is used when working with more than")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" one color per row, in which both colors are carried along the whole row. I usually hold one color in each hand when working with two colors. You can hold one color on each of two fingers of one hand if you prefer. Hold the dominant yarn (this is the pattern color, the one you want to stand out more) in the position where it will always be carried underneath the background color")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("—")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("in the left hand if you are carrying the colors in two hands. These stitches will be slightly larger than the background stitches. If you need to carry one color more than 3 or 4 stitches along, twist it in with the other color along the wrong side so that the float is not ")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("too long. Otherwise, float the yarn not in use along")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v(" the wrong side of the work. Every few stitches, pull the stitches just worked apart from each other a bit")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("—")]), _c('span', {
    staticClass: "Project-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("this prevents your work from getting too tight. If you are combining colorwork with plain knitting in the same project, it is a good idea to use a needle one size larger for the colorwork than for the plain knitting, as most knitters will knit more tightly in stranded colorwork. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame breakBefore"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-6",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-36"
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('a', {
    attrs: {
      "id": "abbreviations"
    }
  }, [_c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("BO")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Bind off."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Ch")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Chain."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("CO")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Cast on."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Dcd (double centered decrease)")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Slip next 2 sts together knitwise to right-hand needle, k1, pass 2 slipped sts over knit stitch."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Dpn")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Double-pointed needle(s)."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("K")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Knit."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("K2tog")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Knit 2 sts together."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("K2tog-tbl")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Knit 2 sts together through back loops. "), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("K3tog")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Knit 3 sts together."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("K1-f/b")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Knit into front loop and back loop of same stitch to increase one stitch."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("K1-tbl")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Knit one stitch through the back loop, twisting the stitch."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("MB")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Make bobble (as instructed)."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("M1R (make 1-right slanting)")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – With the tip of the left-hand needle inserted from back to front, lift the strand between the two needles onto the left-hand needle; knit it through the front loop to increase one stitch."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("M1 or M1L (make 1-left slanting)")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – With the tip of the left-hand needle inserted from front to back, lift the strand between the two needles onto the left-hand needle; knit the strand through the back loop to increase one stitch."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("M1P (make 1 purlwise)")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" - With the tip of the left-hand needle inserted from back to front, lift the strand between the two needles onto the left-hand needle; purl the strand through the front loop to increase one stitch."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Purl."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("P2tog")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Purl 2 sts together."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("P1-f/b")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Purl the next st through the front of its loop, then through the back of its loop, to increase one st."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Pm")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Place marker.")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Psso (pass slipped stitch over)")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Pass slipped st on right-hand needle over the sts indicated in the instructions, as in binding off."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Rnd(s)")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Round(s)."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("RS")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Right side."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Sk2p (double decrease)")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Slip next st knitwise to right-hand needle, k2tog, pass slipped st over st from k2tog."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Sm")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Slip marker."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Ssk (slip, slip, knit)")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Slip the next 2 sts to the right-hand needle one at a time as if to knit; return them back to left-hand needle one at a time in their new orientation; knit them together through the back loop(s)."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Ssp (slip, slip, purl)")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Slip the next 2 sts to right-hand needle one at a time as if to knit; return them to the left-hand needle one at a time in their new orientation; purl them together through the back loop(s)."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("St(s)")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Stitch(es)."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Tbl")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Through the back loop."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("WS")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Wrong side."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Wrp-t")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – Wrap and turn (see Special Techniques, Short Row Shaping)."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Wyib")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" – With yarn in back."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Wyif ")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("– With yarn in front."), _c('br')]), _c('span', {
    staticClass: "Tool-List-body-bold"
  }, [_vm._v("Yo (Yarnover) ")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v("−")]), _c('span', {
    staticClass: "Tool-List-body-copy char-style-override-2",
    staticStyle: {
      "font-size": "0.97em"
    }
  }, [_vm._v(" Bring the yarn forward (to the purl position), then place it in position to work the next stitch. If the next stitch is to be knit, bring the yarn over the needle and knit; if the next stitch is to be purled, bring the yarn over the needle and then forward again to the purl position and purl. Work the yarnover in pattern on the next row unless instructed otherwise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "Project-Body-Copy",
    attrs: {
      "xml:lang": "en-US"
    }
  })])]), _c('a', {
    attrs: {
      "id": "abbreviations"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61df1944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section.vue
// module id = 72
// module chunks = 0